// ── Existing product images ─────────────────────────────────────
import product1     from '../assets/TLC-101.webp';
import product8     from '../assets/TLC-129.webp';
import stripLed     from '../assets/STRIP-LED-POST.webp';
import hangingOld   from '../assets/hanging-230.webp';

// ── HD Product images ───────────────────────────────────────────
import hdTLC108     from '../assets/HD PHOTO/png/png/TLC-108.webp';
import hdTLC118     from '../assets/HD PHOTO/TLC-118.webp';
import hdTLC121     from '../assets/HD PHOTO/TLC-121.webp';
import hdTLC151     from '../assets/HD PHOTO/TLC-151.webp';
import hdTLC152     from '../assets/HD PHOTO/TLC-152.webp';
import hdTLC226     from '../assets/HD PHOTO/TLC-226.webp';
import hdTLC333     from '../assets/HD PHOTO/TLC-333.webp';
import hdTLC335     from '../assets/HD PHOTO/TLC-335.webp';
import hdTLC338     from '../assets/HD PHOTO/TLC-338.webp';
import hdTLC107W    from '../assets/HD PHOTO/png/png/TLC-107 WHITE.webp';
import hdTLC107B    from '../assets/HD PHOTO/png/png/TLC-107 BLACK.webp';
import hdHanging    from '../assets/HD PHOTO/HANGING LIGHT/15/PNG/HANGING LIGHT.webp';
import hdMagCOB     from '../assets/HD PHOTO/CYLINDER/3/PNG/MAGNETIC COB.webp';
import hdCylinder   from '../assets/HD PHOTO/CYLINDER 2/7/PNG/CYLINDER (1).webp';
import hdCaset      from '../assets/HD PHOTO/CASET LAZER 10Z CASTLZR/10/PNG/10Z CASET (1).webp';
import hdLazer10Z   from '../assets/HD PHOTO/LAZER 10Z LZR/18/PNG/10Z LZR.webp';
import hdPRO130     from '../assets/HD PHOTO/PRO+130.webp';
import hdPRO131     from '../assets/HD PHOTO/PRO+131.webp';
import hdPRO132     from '../assets/HD PHOTO/PRO+132.webp';
import hdPRO133     from '../assets/HD PHOTO/PRO+133.webp';
import hdPRO116     from '../assets/HD PHOTO/PRO-116.webp';
import hdPRO120     from '../assets/HD PHOTO/PRO-120.webp';
import hdPRO125     from '../assets/HD PHOTO/PRO-125.webp';
import hdPRO140     from '../assets/HD PHOTO/PRO-140.webp';
import hdPRO126     from '../assets/HD PHOTO/PRO-126.webp';
import hdPRO115     from '../assets/HD PHOTO/PRO-115.webp';
import hdTLC109     from '../assets/HD PHOTO/TLC-109.webp';
import hdTLC111new  from '../assets/HD PHOTO/TLC-111.webp';
import hdTLC107     from '../assets/HD PHOTO/TLC-107.webp';
import hdTLC103     from '../assets/HD PHOTO/TLC-103.webp';
import hdTLC105new  from '../assets/HD PHOTO/TLC-105.webp';
import hdTLC112new  from '../assets/HD PHOTO/TLC-112.webp';
import hdTLC159     from '../assets/HD PHOTO/TLC-159.webp';
import hdTLC102     from '../assets/HD PHOTO/TLC-102.webp';
import hdTLC119     from '../assets/HD PHOTO/TLC-119.webp';
import hdTLC113     from '../assets/HD PHOTO/TLC-113.webp';
import hdTLC114new  from '../assets/HD PHOTO/TLC-114.webp';
import hdPRO142     from '../assets/HD PHOTO/PRO-142.webp';
import hdPRO141     from '../assets/HD PHOTO/PRO-141.webp';

// ── Technical drawing diagrams ──────────────────────────────────
import diaPRO116    from '../assets/diagrams/PRO-116-diagram.webp';
import diaPRO120    from '../assets/diagrams/PRO-120-diagram.webp';
import diaPRO125    from '../assets/diagrams/PRO-125-diagram.webp';
import diaPRO126    from '../assets/diagrams/PRO-126-diagram.webp';
import diaPRO115    from '../assets/diagrams/PRO-115-diagram.webp';
import diaPRO140    from '../assets/diagrams/PRO-140-diagram.webp';
import diaTLC109    from '../assets/diagrams/TLC-109-diagram.webp';
import diaTLC111    from '../assets/diagrams/TLC-111-diagram.webp';
import diaTLC107    from '../assets/diagrams/TLC-107-diagram.webp';
import diaTLC103    from '../assets/diagrams/TLC-103-diagram.webp';
import diaTLC118    from '../assets/diagrams/TLC-118-diagram.webp';
import diaTLC105    from '../assets/diagrams/TLC-105-diagram.webp';
import diaTLC159    from '../assets/diagrams/TLC-159-diagram.webp';
import diaTLC102    from '../assets/diagrams/TLC-102-diagram.webp';
import diaTLC112    from '../assets/diagrams/TLC-112-diagram.webp';
import diaTLC335    from '../assets/diagrams/TLC-335-diagram.webp';
import diaTLC119    from '../assets/diagrams/TLC-119-diagram.webp';
import diaTLC113    from '../assets/diagrams/TLC-113-diagram.webp';
import diaTLC114    from '../assets/diagrams/TLC-114-diagram.webp';
import diaPRO142    from '../assets/diagrams/PRO-142-diagram.webp';
import diaPRO141    from '../assets/diagrams/PRO-141-diagram.webp';

// ── PDF-extracted catalogue (pages 38–138) ──────────────────────
import imgTLC004 from '../assets/HD PHOTO/TLC-004.webp';
import imgPRO130 from '../assets/HD PHOTO/PRO-130.webp';
import imgPRO013 from '../assets/HD PHOTO/PRO-013.webp';
import imgPRO133 from '../assets/HD PHOTO/PRO-133.webp';
import imgPRO131 from '../assets/HD PHOTO/PRO-131.webp';
import imgPRO132 from '../assets/HD PHOTO/PRO-132.webp';
import imgPRO127 from '../assets/HD PHOTO/PRO-127.webp';
import imgTLC108 from '../assets/HD PHOTO/TLC-108.webp';
import imgTLC129 from '../assets/HD PHOTO/TLC-129.webp';
import imgPRO128 from '../assets/HD PHOTO/PRO-128.webp';
import imgTLC101 from '../assets/HD PHOTO/TLC-101.webp';
import imgTLC106 from '../assets/HD PHOTO/TLC-106.webp';
import imgPRO117 from '../assets/HD PHOTO/PRO-117.webp';
import imgTLC144 from '../assets/HD PHOTO/TLC-144.webp';
import imgTLC135 from '../assets/HD PHOTO/TLC-135.webp';
import imgTLC143 from '../assets/HD PHOTO/TLC-143.webp';
import imgTLC145 from '../assets/HD PHOTO/TLC-145.webp';
import imgTLC338 from '../assets/HD PHOTO/TLC-338.webp';
import imgTLC311 from '../assets/HD PHOTO/TLC-311.webp';
import imgTLC334 from '../assets/HD PHOTO/TLC-334.webp';
import imgTLC333 from '../assets/HD PHOTO/TLC-333.webp';
import imgPRO340 from '../assets/HD PHOTO/PRO-340.webp';
import imgPRO240 from '../assets/HD PHOTO/PRO-240.webp';
import imgTLC204 from '../assets/HD PHOTO/TLC-204.webp';
import imgTLC344 from '../assets/HD PHOTO/TLC-344.webp';
import imgTLC339 from '../assets/HD PHOTO/TLC-339.webp';
import imgPRO154 from '../assets/HD PHOTO/PRO-154.webp';
import imgTLC153 from '../assets/HD PHOTO/TLC-153.webp';
import imgTLC152 from '../assets/HD PHOTO/TLC-152.webp';
import imgTLC151 from '../assets/HD PHOTO/TLC-151.webp';
import imgPRO014 from '../assets/HD PHOTO/PRO-014.webp';
import imgPRO054 from '../assets/HD PHOTO/PRO-054.webp';
import imgTLC124 from '../assets/HD PHOTO/TLC-124.webp';
import imgTLC123 from '../assets/HD PHOTO/TLC-123.webp';
import imgTLC121 from '../assets/HD PHOTO/TLC-121.webp';
import imgPRO210 from '../assets/HD PHOTO/PRO-210.webp';
import imgTLC208 from '../assets/HD PHOTO/TLC-208.webp';
import imgPRO209 from '../assets/HD PHOTO/PRO-209.webp';
import imgPRO207 from '../assets/HD PHOTO/PRO-207.webp';
import imgTLC201 from '../assets/HD PHOTO/TLC-201.webp';
import imgTLC206 from '../assets/HD PHOTO/TLC-206.webp';
import imgTLC205 from '../assets/HD PHOTO/TLC-205.webp';
import imgTLC203 from '../assets/HD PHOTO/TLC-203.webp';
import imgTLC155 from '../assets/HD PHOTO/TLC-155.webp';
import imgPRO230 from '../assets/HD PHOTO/PRO-230.webp';
import imgTLC444 from '../assets/HD PHOTO/TLC-444.webp';
import imgPRO232 from '../assets/HD PHOTO/PRO-232.webp';
import imgTLC052 from '../assets/HD PHOTO/TLC-052.webp';
import imgTLC226 from '../assets/HD PHOTO/TLC-226.webp';
import imgTLC089 from '../assets/HD PHOTO/TLC-089.webp';
import imgMAGLAZER from '../assets/HD PHOTO/MAG-LAZER.webp';
import imgMAGMOVE from '../assets/HD PHOTO/MAG-MOVE.webp';
import imgTRACKSPOT from '../assets/HD PHOTO/TRACK-SPOT.webp';
import imgCASETLAZER from '../assets/HD PHOTO/CASET-LAZER.webp';
import imgPROFILE from '../assets/HD PHOTO/PROFILE.webp';
import imgWALLWASHER from '../assets/HD PHOTO/WALL-WASHER.webp';
import imgCYLINDER from '../assets/HD PHOTO/CYLINDER.webp';
import imgTenZCASET from '../assets/HD PHOTO/10Z-CASET.webp';
import imgTenZPFL from '../assets/HD PHOTO/10Z-PFL.webp';
import imgTenZLZR from '../assets/HD PHOTO/10Z-LZR.webp';
import imgTenZTRACK from '../assets/HD PHOTO/10Z-TRACK.webp';
import imgTLC211 from '../assets/HD PHOTO/TLC-211.webp';
import imgTLC213 from '../assets/HD PHOTO/TLC-213.webp';
import imgTLC217 from '../assets/HD PHOTO/TLC-217.webp';
import imgTLC218 from '../assets/HD PHOTO/TLC-218.webp';
import imgTLC219 from '../assets/HD PHOTO/TLC-219.webp';
import imgTLC221 from '../assets/HD PHOTO/TLC-221.webp';
import imgTLC222 from '../assets/HD PHOTO/TLC-222.webp';
import imgTLC223 from '../assets/HD PHOTO/TLC-223.webp';
import imgPRO224 from '../assets/HD PHOTO/PRO-224.webp';
import imgTLC216 from '../assets/HD PHOTO/TLC-216.webp';
import imgTLC220 from '../assets/HD PHOTO/TLC-220.webp';
import imgPRO227 from '../assets/HD PHOTO/PRO-227.webp';
import diaTLC004 from '../assets/diagrams/TLC-004-diagram.webp';
import diaPRO130 from '../assets/diagrams/PRO-130-diagram.webp';
import diaPRO013 from '../assets/diagrams/PRO-013-diagram.webp';
import diaPRO133 from '../assets/diagrams/PRO-133-diagram.webp';
import diaPRO131 from '../assets/diagrams/PRO-131-diagram.webp';
import diaPRO132 from '../assets/diagrams/PRO-132-diagram.webp';
import diaPRO127 from '../assets/diagrams/PRO-127-diagram.webp';
import diaTLC108 from '../assets/diagrams/TLC-108-diagram.webp';
import diaTLC129 from '../assets/diagrams/TLC-129-diagram.webp';
import diaPRO128 from '../assets/diagrams/PRO-128-diagram.webp';
import diaTLC101 from '../assets/diagrams/TLC-101-diagram.webp';
import diaTLC106 from '../assets/diagrams/TLC-106-diagram.webp';
import diaPRO117 from '../assets/diagrams/PRO-117-diagram.webp';
import diaTLC144 from '../assets/diagrams/TLC-144-diagram.webp';
import diaTLC135 from '../assets/diagrams/TLC-135-diagram.webp';
import diaTLC143 from '../assets/diagrams/TLC-143-diagram.webp';
import diaTLC145 from '../assets/diagrams/TLC-145-diagram.webp';
import diaTLC338 from '../assets/diagrams/TLC-338-diagram.webp';
import diaTLC311 from '../assets/diagrams/TLC-311-diagram.webp';
import diaTLC334 from '../assets/diagrams/TLC-334-diagram.webp';
import diaTLC333 from '../assets/diagrams/TLC-333-diagram.webp';
import diaPRO340 from '../assets/diagrams/PRO-340-diagram.webp';
import diaPRO240 from '../assets/diagrams/PRO-240-diagram.webp';
import diaTLC204 from '../assets/diagrams/TLC-204-diagram.webp';
import diaTLC344 from '../assets/diagrams/TLC-344-diagram.webp';
import diaTLC339 from '../assets/diagrams/TLC-339-diagram.webp';
import diaPRO154 from '../assets/diagrams/PRO-154-diagram.webp';
import diaTLC153 from '../assets/diagrams/TLC-153-diagram.webp';
import diaTLC152 from '../assets/diagrams/TLC-152-diagram.webp';
import diaTLC151 from '../assets/diagrams/TLC-151-diagram.webp';
import diaPRO014 from '../assets/diagrams/PRO-014-diagram.webp';
import diaPRO054 from '../assets/diagrams/PRO-054-diagram.webp';
import diaTLC124 from '../assets/diagrams/TLC-124-diagram.webp';
import diaTLC123 from '../assets/diagrams/TLC-123-diagram.webp';
import diaTLC121 from '../assets/diagrams/TLC-121-diagram.webp';
import diaPRO210 from '../assets/diagrams/PRO-210-diagram.webp';
import diaTLC208 from '../assets/diagrams/TLC-208-diagram.webp';
import diaPRO209 from '../assets/diagrams/PRO-209-diagram.webp';
import diaPRO207 from '../assets/diagrams/PRO-207-diagram.webp';
import diaTLC201 from '../assets/diagrams/TLC-201-diagram.webp';
import diaTLC206 from '../assets/diagrams/TLC-206-diagram.webp';
import diaTLC205 from '../assets/diagrams/TLC-205-diagram.webp';
import diaTLC203 from '../assets/diagrams/TLC-203-diagram.webp';
import diaTLC155 from '../assets/diagrams/TLC-155-diagram.webp';
import diaPRO230 from '../assets/diagrams/PRO-230-diagram.webp';
import diaTLC444 from '../assets/diagrams/TLC-444-diagram.webp';
import diaPRO232 from '../assets/diagrams/PRO-232-diagram.webp';
import diaTLC052 from '../assets/diagrams/TLC-052-diagram.webp';
import diaTLC226 from '../assets/diagrams/TLC-226-diagram.webp';
import diaTLC089 from '../assets/diagrams/TLC-089-diagram.webp';
import diaMAGLAZER from '../assets/diagrams/MAG-LAZER-diagram.webp';
import diaMAGMOVE from '../assets/diagrams/MAG-MOVE-diagram.webp';
import diaTRACKSPOT from '../assets/diagrams/TRACK-SPOT-diagram.webp';
import diaCASETLAZER from '../assets/diagrams/CASET-LAZER-diagram.webp';
import diaPROFILE from '../assets/diagrams/PROFILE-diagram.webp';
import diaWALLWASHER from '../assets/diagrams/WALL-WASHER-diagram.webp';
import diaCYLINDER from '../assets/diagrams/CYLINDER-diagram.webp';
import diaTenZCASET from '../assets/diagrams/10Z-CASET-diagram.webp';
import diaTenZPFL from '../assets/diagrams/10Z-PFL-diagram.webp';
import diaTenZLZR from '../assets/diagrams/10Z-LZR-diagram.webp';
import diaTenZTRACK from '../assets/diagrams/10Z-TRACK-diagram.webp';
import diaTLC211 from '../assets/diagrams/TLC-211-diagram.webp';
import diaTLC213 from '../assets/diagrams/TLC-213-diagram.webp';
import diaTLC217 from '../assets/diagrams/TLC-217-diagram.webp';
import diaTLC218 from '../assets/diagrams/TLC-218-diagram.webp';
import diaTLC219 from '../assets/diagrams/TLC-219-diagram.webp';
import diaTLC221 from '../assets/diagrams/TLC-221-diagram.webp';
import diaTLC222 from '../assets/diagrams/TLC-222-diagram.webp';
import diaTLC223 from '../assets/diagrams/TLC-223-diagram.webp';
import diaPRO224 from '../assets/diagrams/PRO-224-diagram.webp';
import diaTLC216 from '../assets/diagrams/TLC-216-diagram.webp';
import diaTLC220 from '../assets/diagrams/TLC-220-diagram.webp';
import diaPRO227 from '../assets/diagrams/PRO-227-diagram.webp';

const ALL_PRODUCTS = [
  // ── PANEL LIGHTS ─────────────────────────────────────────────
  {
    slug: 'tlc-101',
    name: 'TLC-101',
    category: 'Panel Lights',
    categorySlug: 'panel-lights',
    tagline: 'Ultra-Slim Surface Panel',
    image: product1,
    wattage: '12W / 18W / 24W',
    cri: '95+',
    cct: '3000K / 4000K / 6500K',
    ip: 'IP40',
    lifespan: '50,000 hrs',
    description: 'The TLC-101 ultra-slim panel delivers uniform, glare-free illumination ideal for offices, retail spaces, and hospitality environments. Precision-engineered SMD chipset ensures colour consistency across every production batch.',
    features: ['Flicker-free driver', 'Anti-glare diffuser', '10mm slim profile', 'Easy ceiling mount', 'CE & RoHS certified'],
  },
  {
    slug: 'tlc-105',
    name: 'TLC-105',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Mini Recessed COB Downlight',
    image: hdTLC105new,
    diagram: diaTLC105,
    wattage: '5W',
    cri: '80 / 90',
    cct: '3000K / 4000K',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The TLC-105 is a compact 5W mini recessed COB downlight on a Bridgelux LED engine with a Philips driver. Its tiny Ø33mm cutout and Chuangxin reflector make it ideal for accent lighting, niches, and tight ceiling details.',
    features: [
      'Bridgelux LED engine',
      'Philips driver',
      '120–130 LM/W efficacy',
      'Beam angle 38°',
      'Chuangxin reflector',
      'White / Black body',
      'Power factor > 0.90 · 150–240V AC',
      'Ø33mm cutout · 40×43mm body',
    ],
  },
  {
    slug: 'tlc-114',
    name: 'TLC-114',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Recessed Pull-Out Spotlight',
    image: hdTLC114new,
    diagram: diaTLC114,
    wattage: '7W / 12W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The TLC-114 is a recessed pull-out spotlight on a CREE LED engine with a Philips driver. Its cylinder head extends and tilts out of the housing for precise directional accent lighting of artwork, displays, and architectural features.',
    features: [
      'CREE COB LED engine',
      'Philips driver',
      '130–140 LM/W efficacy',
      'Beam angle 24° / 36° / 50°',
      'Pull-out tilt-and-rotate head',
      'Shinland reflector · White / Black',
      'Power factor > 0.90 · 150–240V AC',
      'Cutout 40 / 70mm · Dimmable · DALI',
    ],
  },
  {
    slug: 'tlc-118',
    name: 'TLC-118',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Trimless-Ready COB Downlight',
    image: hdTLC118,
    diagram: diaTLC118,
    wattage: '7W / 12W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The TLC-118 is a recessed COB downlight on a Bridgelux / CREE LED engine with premium Philips, Fulham, or Osram drivers. Offered in standard and trimless versions, its optics deliver clean, even light for residential and commercial ceilings.',
    features: [
      'Bridgelux / CREE COB engine',
      'Driver: Philips / Fulham / Osram',
      '130–140 LM/W efficacy',
      'Beam angle 38° / 50°',
      'Standard & trimless versions',
      'White / Black body',
      'Power factor > 0.90 · 150–240V AC',
      'Cutout 50 / 72mm · Dimmable · DALI',
    ],
  },
  {
    slug: 'tlc-121',
    name: 'TLC-121',
    category: 'Panel Lights',
    categorySlug: 'panel-lights',
    tagline: 'Premium UGR<19 Office Panel',
    image: hdTLC121,
    wattage: '40W / 60W',
    cri: '95+',
    cct: '4000K',
    ip: 'IP40',
    lifespan: '50,000 hrs',
    description: 'UGR<19 anti-glare panel engineered for open-plan offices and education facilities. Meets European EN 12464-1 workplace lighting standards with HF flicker-free operation.',
    features: ['UGR < 19 anti-glare', 'HF flicker-free 50kHz', 'DALI dimmable', 'Pendant or surface mount', 'EN 12464-1 compliant'],
  },
  {
    slug: 'tlc-129',
    name: 'TLC-129',
    category: 'Panel Lights',
    categorySlug: 'panel-lights',
    tagline: 'Backlit Premium Panel',
    image: product8,
    wattage: '36W / 48W',
    cri: '95+',
    cct: '3000K / 4000K',
    ip: 'IP40',
    lifespan: '50,000 hrs',
    description: 'Backlit technology for superior luminous uniformity. The TLC-129 delivers premium performance for corporate, healthcare, and education environments.',
    features: ['Backlit diffuser panel', 'High uniformity >0.85', 'Slim 10mm bezel', 'Easy-access driver bay', 'Recessed or surface'],
  },
  {
    slug: 'tlc-226',
    name: 'TLC-226',
    category: 'Panel Lights',
    categorySlug: 'panel-lights',
    tagline: 'High-Lumen Commercial Panel',
    image: hdTLC226,
    wattage: '45W / 60W / 80W',
    cri: '90+',
    cct: '4000K / 5000K',
    ip: 'IP44',
    lifespan: '50,000 hrs',
    description: 'High-lumen output panel for large commercial spaces, supermarkets, and warehouses requiring consistent overhead illumination across wide spans.',
    features: ['High lumen output', 'IP44 moisture resistant', 'Wide 130° beam', 'PF > 0.95', 'CE & RoHS certified'],
  },
  {
    slug: 'pro-130',
    name: 'PRO+130',
    category: 'Panel Lights',
    categorySlug: 'panel-lights',
    tagline: 'Pro Series Architectural Panel',
    image: hdPRO130,
    wattage: '24W / 36W',
    cri: '95+',
    cct: '3000K / 4000K / 6500K',
    ip: 'IP40',
    lifespan: '50,000 hrs',
    description: 'The PRO+130 architectural panel combines ultra-slim form with precision photometrics for high-end commercial and retail applications demanding premium aesthetics.',
    features: ['Ultra-slim 8mm body', 'Premium light output', 'Anti-glare lens', 'Custom RAL finish option', 'CE certified'],
  },
  {
    slug: 'pro-131',
    name: 'PRO+131',
    category: 'Panel Lights',
    categorySlug: 'panel-lights',
    tagline: 'Pro Series Square Panel',
    image: hdPRO131,
    wattage: '18W / 24W',
    cri: '95+',
    cct: '3000K / 4000K',
    ip: 'IP40',
    lifespan: '50,000 hrs',
    description: 'Square format PRO+ series panel for retail, hospitality, and corporate interiors where architectural detail matters as much as performance.',
    features: ['Slim square format', 'Flush recessed fit', 'Dimmable driver', 'High CRI 95+', 'CE & RoHS certified'],
  },
  {
    slug: 'pro-132',
    name: 'PRO+132',
    category: 'Panel Lights',
    categorySlug: 'panel-lights',
    tagline: 'Pro Series Recessed Panel',
    image: hdPRO132,
    wattage: '36W / 48W',
    cri: '95+',
    cct: '4000K / 5000K',
    ip: 'IP40',
    lifespan: '50,000 hrs',
    description: 'High-performance PRO+132 recessed panel engineered for demanding commercial environments where flicker-free, high-CRI illumination is critical to productivity.',
    features: ['Zero flicker driver', 'CRI 95+ colour accuracy', 'Recessed installation', 'DALI compatible', 'CE certified'],
  },
  {
    slug: 'pro-133',
    name: 'PRO+133',
    category: 'Panel Lights',
    categorySlug: 'panel-lights',
    tagline: 'Pro Series Premium Panel',
    image: hdPRO133,
    wattage: '40W / 60W',
    cri: '95+',
    cct: '3000K / 4000K / 5000K',
    ip: 'IP40',
    lifespan: '50,000 hrs',
    description: 'Top-tier PRO+133 panel with tri-CCT capability and premium build quality. Designed for spaces where versatility and quality of light are paramount.',
    features: ['Tri-CCT selectable', 'Premium aluminium frame', 'UGR < 19', 'Remote dimming option', 'CE & RoHS certified'],
  },

  // ── DOWNLIGHTS ───────────────────────────────────────────────
  {
    slug: 'tlc-108',
    name: 'TLC-108',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Premium Recessed Downlight',
    image: hdTLC108,
    wattage: '7W / 12W / 18W',
    cri: '95+',
    cct: '2700K / 3000K / 4000K',
    ip: 'IP44',
    lifespan: '50,000 hrs',
    description: 'Architectural-grade recessed downlight with a precision reflector for targeted beam control. Perfect for accent lighting in hospitality, residential, and retail environments.',
    features: ['Recessed installation', 'Adjustable beam angle', 'Dimmable (trailing edge)', 'Anti-glare reflector', 'IP44 splash-proof'],
  },
  {
    slug: 'tlc-107-white',
    name: 'TLC-107 White',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Round Architectural Downlight',
    image: hdTLC107W,
    wattage: '12W / 18W',
    cri: '95+',
    cct: '2700K / 3000K / 4000K',
    ip: 'IP44',
    lifespan: '50,000 hrs',
    description: 'Elegant round downlight with a deep-set anti-glare design. Available in white, black, and rose gold finishes for premium hospitality and residential applications.',
    features: ['Deep anti-glare recess', 'Multiple finish options', 'Dimmable', 'IP44 rated', 'Easy clip installation'],
  },
  {
    slug: 'tlc-107-black',
    name: 'TLC-107 Black',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Round Architectural Downlight — Black',
    image: hdTLC107B,
    wattage: '12W / 18W',
    cri: '95+',
    cct: '2700K / 3000K / 4000K',
    ip: 'IP44',
    lifespan: '50,000 hrs',
    description: 'Matte black finish round downlight for dramatic, high-contrast interiors. Deep anti-glare design for premium hospitality, restaurant, and boutique retail spaces.',
    features: ['Matte black finish', 'Deep anti-glare recess', 'Dimmable', 'IP44 rated', 'Tilt-adjustable'],
  },
  {
    slug: 'pro-116',
    name: 'PRO-116',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Anti-Glare COB Recessed Downlight',
    image: hdPRO116,
    diagram: diaPRO116,
    wattage: '10W / 15W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The PRO-116 is a deep anti-glare recessed COB downlight built on a CREE LED engine with premium Philips, Fulham, or Osram drivers. Its aluminium die-cast body delivers excellent thermal performance, available in 10W and 15W, in white or black, with selectable beam angles and full tunable CCT options.',
    features: [
      'CREE COB LED engine',
      'Driver: Philips / Fulham / Osram',
      '130–140 LM/W efficacy',
      'Beam angle 24° / 36° / 60°',
      'Aluminium die-cast body',
      'Shinland anti-glare lens',
      'Power factor > 0.90 · 150–240V AC',
      'White / Black · Dimmable · DALI',
    ],
  },
  {
    slug: 'pro-120',
    name: 'PRO-120',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Adjustable COB Recessed Spotlight',
    image: hdPRO120,
    diagram: diaPRO120,
    wattage: '12W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The PRO-120 is a fully adjustable recessed COB spotlight built on a CREE LED engine with premium Philips, Fulham, or Osram drivers. Its tiltable head and GR precision optics make it ideal for accent lighting of artwork, retail displays, and architectural features.',
    features: [
      'CREE COB LED engine',
      'Driver: Philips / Fulham / Osram',
      '130–140 LM/W efficacy',
      'Beam angle 24° / 36°',
      'GR precision optics',
      'Aluminium die-cast body',
      'Power factor > 0.90 · 150–240V AC',
      'White / Black · Ø40mm cutout · Dimmable · DALI',
    ],
  },
  {
    slug: 'pro-125',
    name: 'PRO-125',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Surface-Mount COB Downlight',
    image: hdPRO125,
    diagram: diaPRO125,
    wattage: '7W / 12W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The PRO-125 is a surface-mounted cylindrical COB downlight on a Bridgelux / CREE LED engine. Its compact aluminium die-cast body and Shinland anti-glare lens deliver clean accent light without recessing, available in white or gun black.',
    features: [
      'Bridgelux / CREE COB engine',
      '130–140 LM/W efficacy',
      'Beam angle 15° / 24° / 36°',
      'Shinland / Darkoo lens',
      'Aluminium die-cast body',
      'Power factor > 0.90 · 150–240V AC',
      'White / Gun Black · Surface mount',
      'Ø40–50mm cutout · Dimmable · DALI',
    ],
  },
  {
    slug: 'pro-126',
    name: 'PRO-126',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'COB Recessed Downlight',
    image: hdPRO126,
    diagram: diaPRO126,
    wattage: '10W / 15W / 20W / 30W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The PRO-126 is a recessed COB downlight available across four power levels on a CREE LED engine with premium Philips, Fulham, or Osram drivers. Its Herculux optics and white/black body-and-reflector options make it a versatile choice for commercial and residential ceilings.',
    features: [
      'CREE COB LED engine',
      'Driver: Philips / Fulham / Osram',
      '130–140 LM/W efficacy',
      'Beam angle 24° / 36° / 50°',
      'Herculux optics',
      'White / Black body & reflector',
      'Power factor > 0.90 · 150–240V AC',
      'Cutout 54–115mm · Dimmable · DALI',
    ],
  },
  {
    slug: 'pro-115',
    name: 'PRO-115',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'IP65 Anti-Glare COB Downlight',
    image: hdPRO115,
    diagram: diaPRO115,
    wattage: '12W / 18W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K',
    ip: 'IP65',
    lifespan: '50,000 hrs',
    description: 'The PRO-115 is an IP65 wet-rated recessed COB downlight on a Bridgelux / CREE LED engine. Built for bathrooms, kitchens, and covered outdoor areas, its deep anti-glare Herculux optic and die-cast aluminium body deliver durable, moisture-resistant accent light.',
    features: [
      'IP65 moisture-rated',
      'Bridgelux / CREE COB engine',
      'Driver: Philips / Fulham',
      '130–140 LM/W efficacy',
      'Beam angle 38°',
      'Herculux anti-glare optic',
      'White / Black body · Black reflector',
      'Cutout 75 / 95mm · Dimmable',
    ],
  },
  {
    slug: 'tlc-109',
    name: 'TLC-109',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Deep Anti-Glare COB Downlight',
    image: hdTLC109,
    diagram: diaTLC109,
    wattage: '10W / 15W / 20W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The TLC-109 is a deep-recessed anti-glare COB downlight on a CREE LED engine with premium Philips, Fulham, or Osram drivers. Its Shinland reflector and trimless aesthetic suit hospitality, retail, and high-end residential ceilings.',
    features: [
      'CREE COB LED engine',
      'Driver: Philips / Fulham / Osram',
      '130–140 LM/W efficacy',
      'Beam angle 38°',
      'Shinland deep reflector',
      'White / Black body',
      'Power factor > 0.90 · 150–240V AC',
      'Cutout 60–85mm · Dimmable · DALI',
    ],
  },
  {
    slug: 'tlc-111',
    name: 'TLC-111',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Wide-Beam Recessed Downlight',
    image: hdTLC111new,
    diagram: diaTLC111,
    wattage: '7W / 12W / 18W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The TLC-111 is a wide-beam recessed downlight on a Bridgelux / CREE LED engine with premium Philips, Fulham, or Osram drivers. Its 80° GR optics and black or rose-gold reflector options deliver broad, even general illumination with a refined finish.',
    features: [
      'Bridgelux / CREE COB engine',
      'Driver: Philips / Fulham / Osram',
      '130–140 LM/W efficacy',
      'Wide 80° beam angle',
      'GR optics · Black / Rose gold reflector',
      'White / Black body',
      'Power factor > 0.90 · 150–240V AC',
      'Cutout 60–90mm · Dimmable · DALI',
    ],
  },
  {
    slug: 'tlc-107',
    name: 'TLC-107',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Anti-Glare COB Downlight',
    image: hdTLC107,
    diagram: diaTLC107,
    wattage: '7W / 12W / 18W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The TLC-107 is an anti-glare recessed COB downlight on a Bridgelux / CREE engine with Philips, Fulham, Osram, or Tirich drivers. Its Chuangxin reflector is offered in white, black, or rose gold to match any interior palette.',
    features: [
      'Bridgelux / CREE COB engine',
      'Driver: Philips / Fulham / Osram / Tirich',
      '120–135 LM/W efficacy',
      'Beam angle 38°',
      'Chuangxin reflector · White / Black / Rose gold',
      'White / Black body',
      'Power factor > 0.90 · 150–240V AC',
      'Cutout 60–85mm · Dimmable · DALI',
    ],
  },
  {
    slug: 'tlc-103',
    name: 'TLC-103',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Compact Deep COB Downlight',
    image: hdTLC103,
    diagram: diaTLC103,
    wattage: '7W / 12W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The TLC-103 is a compact, deep-recessed COB downlight on a Bridgelux / CREE LED engine with premium Philips, Fulham, or Osram drivers. Its small cutout and Shinland reflector make it ideal for tight ceiling plenums and accent applications.',
    features: [
      'Bridgelux / CREE COB engine',
      'Driver: Philips / Fulham / Osram',
      '130–140 LM/W efficacy',
      'Beam angle 24° / 38°',
      'Shinland deep reflector',
      'White / Black body',
      'Power factor > 0.90 · 150–240V AC',
      'Cutout 53 / 62mm · Dimmable · DALI',
    ],
  },
  {
    slug: 'tlc-159',
    name: 'TLC-159',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Mini Recessed COB Spot',
    image: hdTLC159,
    diagram: diaTLC159,
    wattage: '3W',
    cri: '80 / 90',
    cct: '3000K / 4000K',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The TLC-159 is an ultra-compact 3W mini recessed COB spot on a Bridgelux LED engine with a Tirich driver. With a Ø30mm cutout and white, black, or rose-gold reflector, it is built for fine accent lighting and detail work.',
    features: [
      'Bridgelux LED engine',
      'Tirich driver',
      '110–120 LM/W efficacy',
      'Beam angle 38°',
      'Shinland reflector',
      'White / Black / Rose gold',
      'Power factor > 0.90 · 150–240V AC',
      'Ø30mm cutout · 37×29mm body',
    ],
  },
  {
    slug: 'tlc-102',
    name: 'TLC-102',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Multi-Beam COB Downlight',
    image: hdTLC102,
    diagram: diaTLC102,
    wattage: '7W / 12W / 18W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The TLC-102 is a recessed COB downlight on a Bridgelux / CREE engine with Philips, Fulham, Osram, or Tirich drivers. Four selectable beam angles and a Shinland reflector make it a flexible choice for accent through to general lighting.',
    features: [
      'Bridgelux / CREE COB engine',
      'Driver: Philips / Fulham / Osram / Tirich',
      '120–140 LM/W efficacy',
      'Beam angle 15° / 24° / 36° / 60°',
      'Shinland reflector',
      'White / Black body',
      'Power factor > 0.90 · 150–240V AC',
      'Cutout 64–85mm · Dimmable · DALI',
    ],
  },
  {
    slug: 'tlc-119',
    name: 'TLC-119',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'High-Lumen COB Downlight',
    image: hdTLC119,
    diagram: diaTLC119,
    wattage: '50W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The TLC-119 is a high-lumen 50W recessed COB downlight on a Bridgelux / CREE engine with premium Philips, Fulham, or Osram drivers. Its large 145mm cutout and Shinland reflector deliver powerful, even illumination for large commercial spaces.',
    features: [
      'Bridgelux / CREE COB engine',
      'Driver: Philips / Fulham / Osram',
      '130–140 LM/W efficacy',
      'Beam angle 38° / 50°',
      'Shinland reflector',
      'White body',
      'Power factor > 0.90 · 150–240V AC',
      'Ø145mm cutout · 155×82mm body · Dimmable · DALI',
    ],
  },
  {
    slug: 'tlc-113',
    name: 'TLC-113',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Square Single & Twin COB Downlight',
    image: hdTLC113,
    diagram: diaTLC113,
    wattage: '12W / 24W (twin)',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The TLC-113 is a square recessed COB downlight on a Bridgelux / CREE engine with premium Philips, Fulham, or Osram drivers. Available as a single or twin-head frame, its trimless square aperture suits modern, minimal ceilings.',
    features: [
      'Bridgelux / CREE COB engine',
      'Driver: Philips / Fulham / Osram',
      '130–140 LM/W efficacy',
      'Beam angle 24° / 36° / 60°',
      'Single & twin-head frame',
      'White / Black body',
      'Power factor > 0.90 · 150–240V AC',
      'Cutout 75×75mm / 155×77mm · Dimmable · DALI',
    ],
  },
  {
    slug: 'pro-142',
    name: 'PRO+142',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Deep Anti-Glare COB Downlight',
    image: hdPRO142,
    diagram: diaPRO142,
    wattage: '15W / 18W',
    cri: '80 / 90 / 95',
    cct: '3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The PRO+142 is a deep anti-glare recessed COB downlight on a CREE LED engine with an Osram driver. Its Darkoo optic and high-CRI options (up to 95) deliver premium, glare-controlled accent light for retail, hospitality, and galleries.',
    features: [
      'CREE COB LED engine',
      'Osram driver',
      '130–140 LM/W efficacy',
      'Beam angle 38°',
      'Darkoo deep anti-glare optic',
      'CRI up to 95 · White / Black',
      'Power factor > 0.90 · 150–240V AC',
      'Cutout 50 / 62mm · Dimmable · DALI',
    ],
  },
  {
    slug: 'pro-141',
    name: 'PRO+141',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Mini Deep Anti-Glare Downlight',
    image: hdPRO141,
    diagram: diaPRO141,
    wattage: '7W / 12W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The PRO+141 is a compact deep anti-glare recessed COB downlight on a Bridgelux LED engine with premium Philips, Fulham, or Osram drivers. With efficacy up to 160 LM/W and a small cutout, it delivers efficient, low-glare accent light in tight spaces.',
    features: [
      'Bridgelux LED engine',
      'Driver: Philips / Fulham / Osram',
      '150–160 LM/W high efficacy',
      'Beam angle 24° / 38°',
      'Shinland deep reflector',
      'White / Black body',
      'Power factor > 0.90 · 150–240V AC',
      'Cutout 35 / 48mm · Dimmable · DALI',
    ],
  },

  // ── FIXTURES ─────────────────────────────────────────────────
  {
    slug: 'tlc-151',
    name: 'TLC-151',
    category: 'Fixtures',
    categorySlug: 'fixtures',
    tagline: 'Tri-Proof Linear Fixture',
    image: hdTLC151,
    wattage: '18W / 36W / 58W',
    cri: '80+',
    cct: '4000K / 6500K',
    ip: 'IP65',
    lifespan: '50,000 hrs',
    description: 'Tri-proof (dust, water, impact) linear fixture for parking structures, food processing, cold storage, and industrial applications.',
    features: ['IP65 + IK08 rated', 'Polycarbonate body', 'Linkable end-to-end', 'Emergency option available', 'M8 suspension mount'],
  },
  {
    slug: 'tlc-152',
    name: 'TLC-152',
    category: 'Fixtures',
    categorySlug: 'fixtures',
    tagline: 'IP65 Batten Fitting',
    image: hdTLC152,
    wattage: '18W / 36W',
    cri: '80+',
    cct: '4000K / 6500K',
    ip: 'IP65',
    lifespan: '50,000 hrs',
    description: 'Slim waterproof batten fitting for car parks, stairwells, and covered outdoor areas. Robust polycarbonate diffuser rated to IK08 impact resistance.',
    features: ['IP65 waterproof', 'IK08 impact resistant', 'Easy surface mount', 'Integrated driver', 'CE certified'],
  },
  {
    slug: 'tlc-333',
    name: 'TLC-333',
    category: 'Fixtures',
    categorySlug: 'fixtures',
    tagline: 'Industrial UFO High-Bay',
    image: hdTLC333,
    wattage: '150W / 200W / 240W',
    cri: '80+',
    cct: '4000K / 5000K',
    ip: 'IP65',
    lifespan: '50,000 hrs',
    description: 'UFO-style high-bay LED for large industrial and commercial spaces. Superior heat dissipation via die-cast aluminium housing with integrated passive cooling fins.',
    features: ['IP65 + IK08 rated', 'Die-cast aluminium', 'Passive cooling fins', 'Hook & bracket mount', 'Surge protection 6kV'],
  },
  {
    slug: 'tlc-335',
    name: 'TLC-335',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Multi-Power COB Downlight',
    image: hdTLC335,
    diagram: diaTLC335,
    wattage: '6W / 12W / 18W / 30W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The TLC-335 is a recessed COB downlight spanning four power levels on a Bridgelux / CREE engine with Philips, Fulham, Osram, or Tirich drivers. Its Chuangxin reflector and broad size range suit everything from accent niches to general ceiling illumination.',
    features: [
      'Bridgelux / CREE COB engine',
      'Driver: Philips / Fulham / Osram / Tirich',
      '120–140 LM/W efficacy',
      'Beam angle 38° / 50°',
      'Chuangxin reflector',
      'White / Black body',
      'Power factor > 0.90 · 150–240V AC',
      'Cutout 65–135mm · Dimmable · DALI',
    ],
  },
  {
    slug: 'tlc-338',
    name: 'TLC-338',
    category: 'Fixtures',
    categorySlug: 'fixtures',
    tagline: 'Commercial Linear Highbay',
    image: hdTLC338,
    wattage: '80W / 120W / 160W',
    cri: '80+',
    cct: '4000K / 5000K',
    ip: 'IP65',
    lifespan: '50,000 hrs',
    description: 'Linear high-bay for warehouses, supermarkets, and logistics centres requiring high uniformity along aisles and racking rows.',
    features: ['Linear beam distribution', 'IP65 rated', 'Aisle lighting optimised', 'Linkable design', 'Emergency backup option'],
  },
  {
    slug: 'pro-140',
    name: 'PRO-140',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'Recessed Adjustable Spotlight',
    image: hdPRO140,
    diagram: diaPRO140,
    wattage: '7W / 14W (2 × 7W)',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The PRO-140 is a recessed, fully adjustable spotlight on a Bridgelux LED engine with Tirich or Philips drivers. Available as a single head or a twin-head trimless frame, its tilt-and-rotate optics make it ideal for highlighting artwork, niches, and architectural details.',
    features: [
      'Bridgelux LED engine',
      'Driver: Tirich / Philips',
      '130–140 LM/W efficacy',
      'Beam angle 24° / 36°',
      'Single or twin-head frame',
      'Tilt & rotate adjustable optics',
      'White / Black · Power factor > 0.90',
      'Cutout Ø45mm / 92×40mm · Dimmable · DALI',
    ],
  },

  // ── STRIP LEDs ───────────────────────────────────────────────
  {
    slug: 'tlc-112',
    name: 'TLC-112',
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: 'High-Power COB Downlight',
    image: hdTLC112new,
    diagram: diaTLC112,
    wattage: '12W / 24W / 36W',
    cri: '80 / 90',
    cct: '3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'The TLC-112 is a high-power recessed COB downlight on a CREE LED engine with premium Philips, Fulham, or Osram drivers. Its Shinland reflector and larger apertures deliver strong, even output for retail, hospitality, and commercial ceilings.',
    features: [
      'CREE COB LED engine',
      'Driver: Philips / Fulham / Osram',
      '130–140 LM/W efficacy',
      'Beam angle 38°',
      'Shinland reflector',
      'White body',
      'Power factor > 0.90 · 150–240V AC',
      'Cutout 75–130mm · Dimmable · DALI',
    ],
  },
  {
    slug: 'strip-led-pro',
    name: 'Strip LED Pro',
    category: 'Strip LEDs',
    categorySlug: 'strip-leds',
    tagline: 'Commercial Grade LED Strip',
    image: stripLed,
    wattage: '20W/m',
    cri: '95+',
    cct: '2700K / 4000K / 6500K',
    ip: 'IP20 / IP67',
    lifespan: '50,000 hrs',
    description: 'Professional-grade high-density LED strip for commercial cove lighting, architectural highlighting, and display illumination.',
    features: ['120 LEDs/metre density', 'High CRI 95+', 'IP67 waterproof variant', 'Aluminium channel compatible', 'PWM dimming 0–100%'],
  },

  // ── PENDANT LIGHTS ───────────────────────────────────────────
  {
    slug: 'pendant-230',
    name: 'Pendant 230',
    category: 'Pendant Lights',
    categorySlug: 'pendant-lights',
    tagline: 'Architectural Pendant Fixture',
    image: hangingOld,
    wattage: '30W / 45W',
    cri: '95+',
    cct: '2700K / 3000K',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'Designer pendant fixture blending warm illumination with architectural form. Ideal for hospitality, restaurant, and high-end residential spaces.',
    features: ['360° rotatable shade', 'Adjustable cable 0.5–3m', 'Warm dim 2700K option', 'Canopy ceiling plate included', 'Custom finish available'],
  },
  {
    slug: 'hanging-hd',
    name: 'Hanging Light Series',
    category: 'Pendant Lights',
    categorySlug: 'pendant-lights',
    tagline: 'Premium Designer Pendant',
    image: hdHanging,
    wattage: '18W / 24W / 36W',
    cri: '95+',
    cct: '2700K / 3000K',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'Striking architectural pendant for hospitality, fine dining, and luxury residential spaces. Clean geometric form with premium light quality for spaces where design is paramount.',
    features: ['Premium metal housing', 'Adjustable suspension', 'Warm-white optimised', 'Low-glare design', 'Custom finish available'],
  },

  // ── TRACK LIGHTS ─────────────────────────────────────────────
  {
    slug: 'magnetic-cob',
    name: 'Magnetic COB',
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: 'Magnetic LED Track Spotlight',
    image: hdMagCOB,
    wattage: '12W / 18W / 24W',
    cri: '95+',
    cct: '2700K / 3000K / 4000K',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'Magnetic installation COB track spotlight for premium retail, gallery, and museum lighting. Tool-free magnetic snap-on fitting to compatible 48V tracks.',
    features: ['Magnetic snap-on mount', 'COB LED chip', 'Tilt & rotate 350°', 'Dimmable', 'Compatible with 48V track'],
  },
  {
    slug: 'cylinder-track',
    name: 'Cylinder Track',
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: 'Cylinder LED Track Spotlight',
    image: hdCylinder,
    wattage: '15W / 20W / 30W',
    cri: '95+',
    cct: '2700K / 3000K / 4000K',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'Cylindrical track spotlight with a clean minimal aesthetic for contemporary retail and hospitality spaces. Smooth dimming with wide beam angle adjustment.',
    features: ['360° rotation', '30° tilt adjustment', 'Beam angle 24° / 38°', 'Dimmable', 'Universal track adapter'],
  },
  {
    slug: '10z-caset-lazer',
    name: '10Z Caset Lazer',
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: 'Recessed Magnetic Track Spot',
    image: hdCaset,
    wattage: '10W / 15W',
    cri: '95+',
    cct: '2700K / 3000K / 4000K',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'Ultra-slim recessed magnetic track spotlight delivering a laser-sharp beam for precision accent lighting in galleries, retail, and luxury hospitality.',
    features: ['Recessed magnetic fit', 'Ultra-narrow beam', 'Magnetic 48V track', 'Anti-glare lens', 'Dimmable'],
  },
  {
    slug: '10z-lazer',
    name: '10Z Lazer',
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: 'Linear Magnetic Track Module',
    image: hdLazer10Z,
    wattage: '8W / 12W',
    cri: '95+',
    cct: '3000K / 4000K',
    ip: 'IP20',
    lifespan: '50,000 hrs',
    description: 'Compact linear magnetic track module for creating continuous illuminated runs or mixed-module track systems in retail and hospitality environments.',
    features: ['Linear track module', 'Magnetic installation', 'Continuous run capable', 'Dimmable', 'Compatible 48V track'],
  },
  {
    slug: 'tlc-004',
    name: "TLC-004",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "Adjustable Pinhole Mini Downlight",
    image: imgTLC004,
    diagram: diaTLC004,
    wattage: "5W",
    cri: "80 / 90",
    cct: "3000K / 4000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-004 is a recessed mini downlight built on an OSRAM LED engine paired with Tirich or Philips drivers and a Shinland lens. It delivers an efficacy of 150-160 LM/W with a tight 5 degree beam angle for accent and spot applications. The aluminium die-cast body is available in White or Black with a 36mm cutout.",
    features: [
      "OSRAM LED engine",
      "Tirich / Philips drivers",
      "Efficacy 150-160 LM/W",
      "5° narrow beam angle",
      "Shinland lens · aluminium die-cast body",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "45×50mm body · 36mm cutout",
    ],
  },
  {
    slug: 'pro-130-cob',
    name: "PRO+130",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "Recessed Square COB Downlight",
    image: imgPRO130,
    diagram: diaPRO130,
    wattage: "7W / 14W (2×7W)",
    cri: "90",
    cct: "3000K / 4000K / 5000K / 6000K / Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO+130 is a recessed square downlight using a CREE LED engine with an Osram driver and GR optics. It offers an efficacy of 140-150 LM/W and a 36 degree beam angle, available in single and twin (2×7W) configurations. The aluminium die-cast body comes in White or Black and supports DALI dimming and tunable CCT.",
    features: [
      "CREE LED engine",
      "Osram driver",
      "Efficacy 140-150 LM/W",
      "36° beam angle",
      "GR optics · aluminium die-cast body",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · DALI · Tunable",
    ],
  },
  {
    slug: 'pro-013',
    name: "PRO+013",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "Recessed Square Grille Downlight",
    image: imgPRO013,
    diagram: diaPRO013,
    wattage: "7W / 14W (2×7W)",
    cri: "90",
    cct: "3000K / 4000K / 5000K / 6000K / Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO+013 is a recessed square grille downlight built on a CREE LED engine with an Osram driver and GR optics. It achieves an efficacy of 140-150 LM/W with a 36 degree beam angle, offered in single and twin (2×7W) head versions. The aluminium die-cast body is available in White or Black with DALI dimming and tunable CCT.",
    features: [
      "CREE LED engine",
      "Osram driver",
      "Efficacy 140-150 LM/W",
      "36° beam angle",
      "GR optics · aluminium die-cast body",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · DALI · Tunable",
    ],
  },
  {
    slug: 'pro-133-cob',
    name: "PRO+133",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "Recessed Anti-Glare COB Downlight",
    image: imgPRO133,
    diagram: diaPRO133,
    wattage: "15W / 20W",
    cri: "90 / 97",
    cct: "3000K / 4000K / 5000K / 6000K / Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO+133 is a recessed anti-glare downlight using a Citizen LED engine with an Osram driver and GR optics. It delivers an efficacy of 150-160 LM/W with selectable 36, 45 or 60 degree beam angles. The aluminium die-cast body is available in White or Black and supports DALI dimming and tunable CCT.",
    features: [
      "Citizen LED engine",
      "Osram driver",
      "Efficacy 150-160 LM/W",
      "Beam angle 36° / 45° / 60°",
      "GR optics · aluminium die-cast body",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · DALI · Tunable",
    ],
  },
  {
    slug: 'pro-131-cob',
    name: "PRO+131",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "Deep Anti-Glare Downlight",
    image: imgPRO131,
    diagram: diaPRO131,
    wattage: "15W",
    cri: "90 / 97",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO+131 is a recessed deep anti-glare downlight built on a Citizen LED engine with an Osram driver and GR optics. It provides an efficacy of 130-140 LM/W with a 36 degree beam angle. The aluminium die-cast body is available in White or Black and supports DALI dimming, 3-in-1 and tunable CCT.",
    features: [
      "Citizen LED engine",
      "Osram driver",
      "Efficacy 130-140 LM/W",
      "36° beam angle",
      "GR optics · aluminium die-cast body",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · DALI · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'pro-132-cob',
    name: "PRO+132",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "Trimless Plaster-In Downlight",
    image: imgPRO132,
    diagram: diaPRO132,
    wattage: "15W",
    cri: "90 / 97",
    cct: "3000K / 4000K / 5000K / 6000K / Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO+132 is a recessed trimless plaster-in downlight using a Citizen LED engine with an Osram driver and GR optics. It delivers an efficacy of 150-160 LM/W with a 36 degree beam angle. The aluminium die-cast body is available in White or Black and supports DALI dimming and tunable CCT.",
    features: [
      "Citizen LED engine",
      "Osram driver",
      "Efficacy 150-160 LM/W",
      "36° beam angle",
      "GR optics · trimless plaster-in",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · DALI · Tunable",
    ],
  },
  {
    slug: 'pro-127',
    name: "PRO-127",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "Anti-Glare Spot Downlight",
    image: imgPRO127,
    diagram: diaPRO127,
    wattage: "7W / 12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO-127 is a recessed anti-glare spot downlight built on a Bridgelux LED engine with a Bag driver and GR optics. It achieves an efficacy of 140-150 LM/W with selectable 24 or 36 degree beam angles. The aluminium die-cast body is available in White or Gun Black and supports DALI dimming and tunable CCT.",
    features: [
      "Bridgelux LED engine",
      "Bag driver",
      "Efficacy 140-150 LM/W",
      "Beam angle 24° / 36°",
      "GR optics · aluminium die-cast body",
      "Body colour: White / Gun Black",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · DALI · Tunable",
    ],
  },
  {
    slug: 'tlc-108-deep',
    name: "TLC-108",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "Recessed Deep COB Downlight",
    image: imgTLC108,
    diagram: diaTLC108,
    wattage: "7W / 12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-108 is a recessed deep anti-glare downlight using Bridgelux and CREE LED engines with Philips, Fulham or Osram drivers and a Shinland reflector. It delivers an efficacy of 130-140 LM/W with selectable 38 or 24 degree beam angles. The aluminium die-cast body is available in White or Black and supports DALI dimming, 3-in-1 and tunable CCT.",
    features: [
      "Bridgelux / CREE LED engine",
      "Driver: Philips / Fulham / Osram",
      "Efficacy 130-140 LM/W",
      "Beam angle 24° / 38°",
      "Shinland reflector",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · DALI · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'tlc-129-cob',
    name: "TLC-129",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "Anti-Glare COB Downlight",
    image: imgTLC129,
    diagram: diaTLC129,
    wattage: "7W / 12W / 18W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-129 is a recessed anti-glare downlight built on a Bridgelux LED engine with Tirich, Philips, Fulham or Osram drivers and GR optics. It achieves an efficacy of 130-140 LM/W with selectable 15, 24, 36 or 50 degree beam angles. The aluminium die-cast body is available in White or Black and supports DALI dimming, 3-in-1 and tunable CCT.",
    features: [
      "Bridgelux LED engine",
      "Driver: Tirich / Philips / Fulham / Osram",
      "Efficacy 130-140 LM/W",
      "Beam angle 15° / 24° / 36° / 50°",
      "GR optics · aluminium die-cast body",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · DALI · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'pro-128',
    name: "PRO-128",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "Recessed COB Downlight",
    image: imgPRO128,
    diagram: diaPRO128,
    wattage: "10W",
    cri: "80",
    cct: "4000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO-128 is a recessed downlight using a Bridgelux LED engine with an imported HPF driver and a Shinland reflector. It delivers an efficacy of 120 LM/W with a 36 degree beam angle. The aluminium die-cast body is available in White with a 75mm cutout.",
    features: [
      "Bridgelux LED engine",
      "Imported HPF driver",
      "Efficacy 120 LM/W",
      "36° beam angle",
      "Shinland reflector",
      "Body colour: White",
      "Power factor > 0.90 · 150–240V AC",
      "85×48mm body · 75mm cutout",
    ],
  },
  {
    slug: 'tlc-101-cob',
    name: "TLC-101",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "COB Recessed Downlight",
    image: imgTLC101,
    diagram: diaTLC101,
    wattage: "7W / 12W / 18W / 24W / 40W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-101 (Flavacob) is an aluminium die-cast recessed COB downlight built on Bridgelux and CREE LED engines driven by Philips, Fulham or Osram drivers. It uses a Shinland reflector with selectable 15°, 24°, 36° and 60° beam angles and delivers 120-140 LM/W. Available in white and black bodies across five wattages from 7W to 40W.",
    features: [
      "Bridgelux / CREE LED engine",
      "Driver: Philips / Fulham / Osram",
      "120-140 LM/W efficacy",
      "Beam angle 15° / 24° / 36° / 60°",
      "Shinland reflector",
      "Body colour: White / Black",
      "Power factor > 0.95 · 220–240V AC",
      "Cutout 60–130mm · Dimmable · DALI",
    ],
  },
  {
    slug: 'tlc-106',
    name: "TLC-106",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "COB Recessed Spot Downlight",
    image: imgTLC106,
    diagram: diaTLC106,
    wattage: "10W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-106 is an aluminium die-cast recessed COB downlight using CREE and Bridgelux LEDs with a Bag driver. It features a Shinland reflector with a 24° beam angle and delivers a high 140-160 LM/W. Offered as a 10W unit in white and black bodies.",
    features: [
      "CREE / Bridgelux LED engine",
      "Bag driver",
      "140-160 LM/W efficacy",
      "24° beam angle",
      "Shinland reflector",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "34mm cutout · Dimmable · DALI",
    ],
  },
  {
    slug: 'pro-117',
    name: "PRO-117",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "Mini COB Recessed Downlight",
    image: imgPRO117,
    diagram: diaPRO117,
    wattage: "5W",
    cri: "80 / 90",
    cct: "3000K / 4000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO-117 is a compact aluminium die-cast recessed downlight powered by an OSRAM LED with a Tirich driver. It uses a Shinland reflector with a narrow 10° beam angle and delivers 140-150 LM/W. Available as a 5W unit in white and black bodies.",
    features: [
      "OSRAM LED engine",
      "Tirich driver",
      "140-150 LM/W efficacy",
      "10° narrow beam angle",
      "Shinland reflector",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "30×66mm body · 22mm cutout",
    ],
  },
  {
    slug: 'tlc-144',
    name: "TLC-144",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "COB Recessed Downlight",
    image: imgTLC144,
    diagram: diaTLC144,
    wattage: "7W / 12W / 18W / 24W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-144 is an aluminium die-cast recessed COB downlight using a CREE LED engine with an imported driver. It has a Shinland reflector with a 38° beam angle and delivers 130-140 LM/W. Available in white and black bodies across four wattages from 7W to 24W.",
    features: [
      "CREE LED engine",
      "Imported driver",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "Shinland reflector",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · DALI · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'tlc-135',
    name: "TLC-135",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "COB Recessed Downlight",
    image: imgTLC135,
    diagram: diaTLC135,
    wattage: "7W / 12W / 18W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-135 is an aluminium die-cast recessed COB downlight driven by a Philips driver with a Shinland reflector. It offers a 38° beam angle and delivers 130-140 LM/W. Available in white and black bodies across three wattages from 7W to 18W.",
    features: [
      "COB LED engine",
      "Philips driver",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "Shinland reflector",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · DALI · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'tlc-143',
    name: "TLC-143",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "COB Recessed Downlight",
    image: imgTLC143,
    diagram: diaTLC143,
    wattage: "12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-143 is an aluminium die-cast recessed COB downlight using a Bridgelux LED engine with an imported driver. It features a Shinland reflector with a 38° beam angle and delivers 130-140 LM/W. Offered as a 12W unit in white, black and wooden finishes.",
    features: [
      "Bridgelux LED engine",
      "Imported driver",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "Shinland reflector",
      "Body colour: White / Black / Wooden",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · DALI · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'tlc-145',
    name: "TLC-145",
    category: 'COB Lights',
    categorySlug: 'cob-lights',
    tagline: "COB Recessed Downlight",
    image: imgTLC145,
    diagram: diaTLC145,
    wattage: "7W / 12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-145 is an aluminium die-cast recessed COB downlight built on a Bridgelux LED engine with an imported driver. It uses a Shinland reflector with a 38° beam angle and delivers 130-140 LM/W. Available in white and black bodies in 7W and 12W.",
    features: [
      "Bridgelux LED engine",
      "Imported driver",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "Shinland reflector",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · DALI · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'tlc-338-downlight',
    name: "TLC-338",
    category: 'Downlights',
    categorySlug: 'downlights',
    tagline: "Recessed Diffused Downlight",
    image: imgTLC338,
    diagram: diaTLC338,
    wattage: "16W / 24W / 32W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 6000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-338 is an aluminium die-cast recessed downlight using a Bridgelux LED engine with a Tirich driver and a Yongtek diffuser. It offers a wide 110° beam angle and delivers 130-140 LM/W. Available in white bodies across three wattages from 16W to 32W.",
    features: [
      "Bridgelux LED engine",
      "Tirich driver",
      "130-140 LM/W efficacy",
      "110° wide beam angle",
      "Yongtek diffuser",
      "Body colour: White",
      "Power factor > 0.90 · 150–240V AC",
      "Cutout 105–205mm · 120–225mm body",
    ],
  },
  {
    slug: 'tlc-311',
    name: "TLC-311",
    category: 'Downlights',
    categorySlug: 'downlights',
    tagline: "Recessed Diffused Downlight",
    image: imgTLC311,
    diagram: diaTLC311,
    wattage: "12W / 18W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-311 is an aluminium die-cast recessed downlight built on Bridgelux and OSRAM LEDs with Philips, Fulham, Osram or Tirich drivers and a Yongtek diffuser. It offers a wide 110° beam angle and delivers 120-130 LM/W. Available in white and black bodies in 12W and 18W.",
    features: [
      "Bridgelux / OSRAM LED engine",
      "Driver: Philips / Fulham / Osram / Tirich",
      "120-130 LM/W efficacy",
      "110° wide beam angle",
      "Yongtek diffuser",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Cutout 90–115mm · Dimmable · DALI",
    ],
  },
  {
    slug: 'tlc-334',
    name: "TLC-334",
    category: 'Downlights',
    categorySlug: 'downlights',
    tagline: "Recessed Diffused Downlight",
    image: imgTLC334,
    diagram: diaTLC334,
    wattage: "12W / 18W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-334 is an aluminium die-cast recessed round downlight built on Bridgelux and OSRAM LEDs with Philips or Tirich drivers and a Yongtek diffuser. It offers a wide 110° beam angle and delivers 120-130 LM/W. Available in white and black bodies in 12W and 18W.",
    features: [
      "Bridgelux / OSRAM LED engine",
      "Driver: Philips / Tirich",
      "120-130 LM/W efficacy",
      "110° wide beam angle",
      "Yongtek diffuser",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Cutout 100–145mm · Dimmable · DALI",
    ],
  },
  {
    slug: 'tlc-333-downlight',
    name: "TLC-333",
    category: 'Downlights',
    categorySlug: 'downlights',
    tagline: "Recessed Round Downlight",
    image: imgTLC333,
    diagram: diaTLC333,
    wattage: "12W / 18W / 24W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-333 is a recessed round LED downlight built from aluminium die casting with a Yongtek diffuser and a wide 110° beam angle. It is powered by Bridgelux / Osram LEDs with Philips, Fulham, Osram or Tirich drivers and offers a power factor above 0.90. Available in 12W, 18W and 24W with cutouts from 110mm to 160mm.",
    features: [
      "Bridgelux / Osram LED engine",
      "Driver: Philips / Fulham / Osram / Tirich",
      "110° wide beam angle",
      "Yongtek diffuser",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Cutout 110 / 140 / 160mm",
      "Dimmable · DALI · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'pro-340',
    name: "PRO-340",
    category: 'Downlights',
    categorySlug: 'downlights',
    tagline: "Compact Recessed Downlight",
    image: imgPRO340,
    diagram: diaPRO340,
    wattage: "12W / 18W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO-340 is a compact recessed LED downlight in aluminium die casting with a Yongtek diffuser and a 110° beam angle. It uses Bridgelux / Osram LEDs with high efficacy of 120-135 LM/W and Philips, Tirich or Bag drivers. Offered in 12W and 18W with cutouts of 75mm and 105mm.",
    features: [
      "Bridgelux / Osram LED engine",
      "Driver: Philips / Tirich / Bag",
      "120-135 LM/W efficacy",
      "110° wide beam angle",
      "Yongtek diffuser",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Cutout 75 / 105mm · Dimmable · DALI",
    ],
  },
  {
    slug: 'pro-240',
    name: "PRO-240",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface-Mounted Cylinder Spot",
    image: imgPRO240,
    diagram: diaPRO240,
    wattage: "7W / 12W / 18W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO-240 is a surface/ceiling-mounted cylindrical LED light in aluminium die casting with a Shinland reflector and a focused 38° beam angle. It is built on CREE LEDs with high efficacy of 130-140 LM/W and a power factor above 0.90. Available in 7W, 12W and 18W in White or Black.",
    features: [
      "CREE LED engine",
      "Surface / ceiling mounted cylinder",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "Shinland reflector",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · DALI · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'tlc-204',
    name: "TLC-204",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface-Mounted Spot Light",
    image: imgTLC204,
    diagram: diaTLC204,
    wattage: "7W / 12W / 18W / 30W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-204 is a surface-mounted cylindrical spot light in aluminium die casting with a Shinland / GR Optics lens and a focused 38° beam angle. It runs on Bridgelux LEDs with a Fulham driver, high efficacy of 130-140 LM/W and a power factor above 0.96. Available in 7W to 30W with Black or Rose Gold reflector options.",
    features: [
      "Bridgelux LED engine",
      "Fulham driver",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "Shinland / GR Optics lens",
      "Reflector: Black / Rose Gold",
      "Body colour: White / Black",
      "Power factor > 0.96 · 150–240V AC",
    ],
  },
  {
    slug: 'tlc-344',
    name: "TLC-344",
    category: 'Downlights',
    categorySlug: 'downlights',
    tagline: "Recessed Round Downlight",
    image: imgTLC344,
    diagram: diaTLC344,
    wattage: "12W / 18W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-344 is a recessed round LED downlight in aluminium die casting with a Shinland reflector and a 38° beam angle. It delivers high efficacy of 130-140 LM/W with a power factor above 0.98. Available in 12W and 18W in White or Black.",
    features: [
      "COB LED engine",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "Shinland reflector",
      "Aluminium die-cast body",
      "Body colour: White / Black",
      "Power factor > 0.98 · 150–240V AC",
      "Recessed mounting",
    ],
  },
  {
    slug: 'tlc-339',
    name: "TLC-339",
    category: 'Panel Lights',
    categorySlug: 'panel-lights',
    tagline: "Surface Square Panel",
    image: imgTLC339,
    diagram: diaTLC339,
    wattage: "40W",
    cri: "80 / 90",
    cct: "4000K / 6000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-339 is a flat square LED panel in aluminium die casting with a diffused face, delivering high efficacy of 130-140 LM/W. It runs on Bridgelux LEDs with a Fulham driver and a power factor above 0.93. Available in 40W with a White finish.",
    features: [
      "Bridgelux LED engine",
      "Fulham driver",
      "130-140 LM/W efficacy",
      "Flat square panel form",
      "CCT 4000K / 6000K",
      "Body colour: White",
      "Power factor > 0.93 · 150–240V AC",
      "Aluminium die-cast body",
    ],
  },
  {
    slug: 'pro-154',
    name: "PRO-154",
    category: 'Linear Lights',
    categorySlug: 'linear-lights',
    tagline: "Linear Grille Downlight",
    image: imgPRO154,
    diagram: diaPRO154,
    wattage: "6W / 12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO-154 is a linear grille recessed LED downlight in aluminium die casting with a Shinland lens and a focused 38° beam angle. It uses Bridgelux / Osram LEDs with Philips, Fulham or Osram drivers and high efficacy of 130-140 LM/W. Available in 6W and 12W multi-cell bars with cutouts of 95×32mm and 152×32mm.",
    features: [
      "Bridgelux / Osram LED engine",
      "Driver: Philips / Fulham / Osram",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "Linear multi-cell grille",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Cutout 95×32 / 152×32mm · DALI",
    ],
  },
  {
    slug: 'tlc-153',
    name: "TLC-153",
    category: 'Linear Lights',
    categorySlug: 'linear-lights',
    tagline: "Linear Grille Downlight",
    image: imgTLC153,
    diagram: diaTLC153,
    wattage: "6W / 12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-153 is a linear grille recessed LED downlight in aluminium die casting with a Shinland reflector and a focused 38° beam angle. It is built on Bridgelux LEDs with Philips, Fulham or Osram drivers and high efficacy of 130-140 LM/W. Available in 6W and 12W multi-cell bars with a 30mm cell width and Black or Rose Gold reflectors.",
    features: [
      "Bridgelux LED engine",
      "Driver: Philips / Fulham / Osram",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "Linear multi-cell grille",
      "Reflector: Black / Rose Gold",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC · DALI",
    ],
  },
  {
    slug: 'tlc-152-magik',
    name: "TLC-152 (Magik)",
    category: 'Linear Lights',
    categorySlug: 'linear-lights',
    tagline: "Modular Linear Grille Downlight",
    image: imgTLC152,
    diagram: diaTLC152,
    wattage: "5W / 15W / 16W / 20W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-152 Magik is a modular linear grille recessed LED downlight in aluminium die casting with a GR Optics lens and a focused 38° beam angle. It uses Bridgelux LEDs with Philips, Fulham or Osram drivers and high efficacy of 130-140 LM/W. Available in 5W to 20W with single, multi-cell and square configurations and cutouts from 42×42mm to 195×42mm.",
    features: [
      "Bridgelux LED engine",
      "Driver: Philips / Fulham / Osram",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "Modular linear grille · GR Optics",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Cutout 42×42 to 195×42mm · DALI · Tunable",
    ],
  },
  {
    slug: 'tlc-151-linea-lazer',
    name: "TLC-151 (Linea Lazer)",
    category: 'Linear Lights',
    categorySlug: 'linear-lights',
    tagline: "Linear Grille Downlight",
    image: imgTLC151,
    diagram: diaTLC151,
    wattage: "3W / 4W / 6W / 12W / 20W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-151 Linea Lazer is a linear grille recessed LED downlight in aluminium die casting with a Shinland reflector and a focused 38° beam angle. It runs on Bridgelux LEDs with Philips, Fulham or Osram drivers and efficacy of 120-130 LM/W. Available in 3W to 20W multi-cell bars with cutouts from 35×35mm to 260×35mm and Black or Rose Gold reflectors.",
    features: [
      "Bridgelux LED engine",
      "Driver: Philips / Fulham / Osram",
      "120-130 LM/W efficacy",
      "38° beam angle",
      "Linear multi-cell grille",
      "Reflector: Black / Rose Gold",
      "Power factor > 0.90 · 150–240V AC",
      "Cutout 35×35 to 260×35mm · DALI · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'pro-014',
    name: "PRO-014",
    category: 'Linear Lights',
    categorySlug: 'linear-lights',
    tagline: "Linear Grille Downlight",
    image: imgPRO014,
    diagram: diaPRO014,
    wattage: "6W / 10W",
    cri: "80",
    cct: "3000K / 4000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO-014 is a recessed linear grille downlight built from die-cast aluminium and fitted with OSRAM LEDs and GR optics. It delivers 130 LM/W at a 24° beam angle and is available in 6W and 10W versions for 65×25mm and 105×25mm cutouts. The trimless module recesses flush into the ceiling for a discreet linear accent.",
    features: [
      "OSRAM LED engine",
      "Imported HPF driver",
      "130 LM/W efficacy",
      "24° beam angle",
      "GR optics · trimless module",
      "Body colour: White / Black",
      "Power factor > 0.95 · 220–240V AC",
      "Cutout 65×25 / 105×25mm",
    ],
  },
  {
    slug: 'pro-054',
    name: "PRO-054",
    category: 'Linear Lights',
    categorySlug: 'linear-lights',
    tagline: "Linear Grille Downlight",
    image: imgPRO054,
    diagram: diaPRO054,
    wattage: "12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO-054 is a recessed linear grille downlight using Bridgelux LEDs driven by a Fulham driver with GR optics. It produces 130 LM/W across a 36° beam and offers tunable and DALI-dimmable options. The 12W module fits a 157×55mm cutout and recesses cleanly into the ceiling.",
    features: [
      "Bridgelux LED engine",
      "Fulham driver",
      "130 LM/W efficacy",
      "36° beam angle",
      "GR optics · linear grille",
      "Body colour: White / Black",
      "Power factor > 0.95 · 150–240V AC",
      "Cutout 157×55mm · DALI · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'tlc-124',
    name: "TLC-124",
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: "Track-Mounted COB Spotlight",
    image: imgTLC124,
    diagram: diaTLC124,
    wattage: "20W / 30W / 40W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-124 is a track-mounted COB spotlight with a finned die-cast aluminium body and a Darkoo reflector. Powered by Bridgelux or CREE LEDs with Philips, Fulham or Osram drivers, it reaches 130-140 LM/W at a 38° beam. Available in 20W, 30W and 40W versions for track-rail mounting and adjustable accent lighting.",
    features: [
      "Bridgelux / CREE LED engine",
      "Driver: Philips / Fulham / Osram",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "Darkoo reflector",
      "Track-rail mount · tilt & rotate",
      "Power factor > 0.90 · 150–240V AC",
      "Body colour: White / Black",
    ],
  },
  {
    slug: 'tlc-123',
    name: "TLC-123",
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: "Track-Mounted Spotlight",
    image: imgTLC123,
    diagram: diaTLC123,
    wattage: "20W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-123 is a compact track-mounted spotlight in black die-cast aluminium with a Shinland reflector and Bridgelux LEDs. It offers a 3-in-1 beam-angle change of 15°, 36° and 60° and delivers 130-140 LM/W. The 20W head mounts on a track rail for flexible, focused accent lighting.",
    features: [
      "Bridgelux LED engine",
      "Imported HPF driver",
      "130-140 LM/W efficacy",
      "3-in-1 beam change 15° / 36° / 60°",
      "Shinland reflector",
      "Track-rail mount",
      "Power factor > 0.90 · 150–240V AC",
      "Body colour: Black",
    ],
  },
  {
    slug: 'tlc-121-track',
    name: "TLC-121",
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: "Track-Mounted COB Spotlight",
    image: imgTLC121,
    diagram: diaTLC121,
    wattage: "10W / 20W / 30W / 40W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-121 is a cylindrical track-mounted COB spotlight built from die-cast aluminium with a Shinland reflector. Driven by Philips, Fulham, Osram or Tirich drivers and Bridgelux or CREE LEDs, it produces 120-140 LM/W at a 38° beam. Four wattages from 10W to 40W mount on a track rail for scalable accent lighting.",
    features: [
      "Bridgelux / CREE LED engine",
      "Driver: Philips / Fulham / Osram / Tirich",
      "120-140 LM/W efficacy",
      "38° beam angle",
      "Shinland reflector",
      "Track-rail mount · Dimmable",
      "Power factor > 0.90 · 150–240V AC",
      "Body colour: White / Black · Tunable",
    ],
  },
  {
    slug: 'pro-210',
    name: "PRO-210 (Frame Highlighter)",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface Frame Highlighter",
    image: imgPRO210,
    diagram: diaPRO210,
    wattage: "12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO-210 is a surface-mounted frame highlighter that uses CREE LEDs with optics to shape light into spot, circle or linear forms. Built from die-cast aluminium with an adjustable yoke mount, it delivers 130-140 LM/W at a 38° beam. The 12W black fixture is designed to crisply highlight artwork and framed objects.",
    features: [
      "CREE LED engine",
      "Tirich driver",
      "130-140 LM/W efficacy",
      "38° beam angle · shape optics",
      "Adjustable yoke surface mount",
      "Body colour: Black",
      "Power factor > 0.90 · 150–240V AC",
      "Spot / circle / linear highlight",
    ],
  },
  {
    slug: 'tlc-208',
    name: "TLC-208",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Adjustable Surface Spotlight",
    image: imgTLC208,
    diagram: diaTLC208,
    wattage: "12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-208 is an adjustable surface-mounted spotlight available in both surface and recessed configurations with a black reflector. It uses CREE or Bridgelux LEDs with Philips, Fulham, Osram or Tirich drivers and a Shinland lens for 120-130 LM/W output. The 12W head tilts on its mount for directional accent lighting.",
    features: [
      "CREE / Bridgelux LED engine",
      "Driver: Philips / Fulham / Osram / Tirich",
      "120-130 LM/W efficacy",
      "38° beam angle",
      "Shinland lens · black reflector",
      "Adjustable surface-mount head",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'pro-209',
    name: "PRO-209",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface Adjustable Spotlight",
    image: imgPRO209,
    diagram: diaPRO209,
    wattage: "12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO-209 is a surface-mounted adjustable spotlight with a rotating head on a die-cast aluminium base, fitted with CREE LEDs and optics. It produces 130-140 LM/W at a 38° beam and offers 3-in-1 selectable colour temperature. The 12W fixture rotates and tilts for flexible directional accent lighting.",
    features: [
      "CREE LED engine",
      "Tirich driver",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "Rotating & tilting head",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Dimmable · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'pro-207',
    name: "PRO-207",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface Cylinder Downlight",
    image: imgPRO207,
    diagram: diaPRO207,
    wattage: "15W / 22W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO-207 is a surface-mounted cylinder downlight in die-cast aluminium with a Yongtek diffuser for wide, even illumination. Fitted with Bridgelux or OSRAM LEDs and Fulham or Tirich drivers, it delivers 130-140 LM/W across a wide 110° beam. Available in 15W and 22W versions for general surface ceiling lighting.",
    features: [
      "Bridgelux / OSRAM LED engine",
      "Driver: Fulham / Tirich",
      "130-140 LM/W efficacy",
      "110° wide beam angle",
      "Yongtek diffuser",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Surface cylinder mount",
    ],
  },
  {
    slug: 'tlc-201',
    name: "TLC-201",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface Cylinder Downlight",
    image: imgTLC201,
    diagram: diaTLC201,
    wattage: "12W / 18W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-201 is a surface-mounted cylinder downlight built from die-cast aluminium with a Yongtek diffuser and Bridgelux LEDs. It produces 130-140 LM/W across a wide 110° beam with 3-in-1 selectable colour temperature. Available in 12W and 18W versions and white, black or wooden finishes for general surface ceiling lighting.",
    features: [
      "Bridgelux LED engine",
      "Tirich driver",
      "130-140 LM/W efficacy",
      "110° wide beam angle",
      "Yongtek diffuser",
      "Body colour: White / Black / Wooden",
      "Power factor > 0.90 · 150–240V AC",
      "Surface cylinder · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'tlc-206',
    name: "TLC-206",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface Cylinder Spotlight",
    image: imgTLC206,
    diagram: diaTLC206,
    wattage: "7W / 12W / 18W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-206 is a surface-mounted cylindrical spotlight with an aluminium die-cast body and Shinland / GR Optics reflector. It runs on Bridgelux / CREE LEDs with a 38° beam angle and 130-140 LM/W output. Available in 7W, 12W and 18W with a black or rose gold reflector finish.",
    features: [
      "Bridgelux / CREE LED engine",
      "Driver: Philips / Fulham / Osram / Tirich",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "Shinland / GR Optics reflector",
      "Reflector: Black / Rose Gold",
      "Body colour: White / Black",
      "Power factor > 0.90 · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'tlc-205',
    name: "TLC-205",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface Cylinder, Wood Finish",
    image: imgTLC205,
    diagram: diaTLC205,
    wattage: "7W / 12W / 18W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-205 is a surface-mounted cylindrical spotlight featuring a wooden-finish aluminium die-cast body with GR Optics reflector. Powered by Bridgelux / CREE LEDs, it delivers 130-140 LM/W at a 38° beam angle. Offered in 7W, 12W and 18W with black or rose gold reflector options.",
    features: [
      "Bridgelux / CREE LED engine",
      "Driver: Philips / Fulham / Osram / Tirich",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "GR Optics reflector",
      "Wooden-finish die-cast body",
      "Reflector: Black / Rose Gold",
      "Power factor > 0.90 · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'tlc-203',
    name: "TLC-203",
    category: 'Pendant Lights',
    categorySlug: 'pendant-lights',
    tagline: "Suspended Cylinder Pendant",
    image: imgTLC203,
    diagram: diaTLC203,
    wattage: "7W / 12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-203 is a slim suspended cylindrical pendant with an aluminium die-cast body and GR Optics reflector. It uses Bridgelux / CREE LEDs at 130-140 LM/W with a 38° beam angle. Available in 7W (50×200mm) and 12W (50×300mm) with white, black or wooden body finishes.",
    features: [
      "Bridgelux / CREE LED engine",
      "Driver: Philips / Fulham / Osram / Tirich",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "GR Optics reflector",
      "Body colour: White / Black / Wooden",
      "Suspended pendant mount",
      "Power factor > 0.90 · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'tlc-155',
    name: "TLC-155",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface Linear Bar Light",
    image: imgTLC155,
    diagram: diaTLC155,
    wattage: "12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 3-in-1 Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-155 is a surface-mounted linear bar fixture with five recessed cells in an aluminium die-cast body and Shinland lens. It runs Bridgelux LEDs at 130-140 LM/W with a 38° beam angle. Supplied at 12W with 135×35mm dimensions and a 55mm height in white or black.",
    features: [
      "Bridgelux LED engine",
      "Tirich driver",
      "130-140 LM/W efficacy",
      "38° beam angle",
      "Shinland lens · 5-cell linear bar",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "135×35mm · 3-in-1 Tunable",
    ],
  },
  {
    slug: 'pro-230',
    name: "PRO-230",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface Cylinder Spotlight",
    image: imgPRO230,
    diagram: diaPRO230,
    wattage: "7W / 12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO-230 is a surface-mounted cylindrical spotlight with an aluminium die-cast body and Shinland reflector. It uses Bridgelux LEDs at 130 LM/W with selectable 24° and 38° beam angles. Available in 7W (54×80mm) and 12W (72×90mm) in white or black.",
    features: [
      "Bridgelux LED engine",
      "Fulham driver",
      "130 LM/W efficacy",
      "Beam angle 24° / 38°",
      "Shinland reflector",
      "Body colour: White / Black",
      "Power factor > 0.95 · 150–240V AC",
      "Surface cylinder mount",
    ],
  },
  {
    slug: 'tlc-444',
    name: "TLC-444",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface Round Light",
    image: imgTLC444,
    diagram: diaTLC444,
    wattage: "12W / 18W / 24W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-444 is a surface-mounted round light with an aluminium die-cast body and Yongtek diffuser. It runs Bridgelux LEDs at 120-130 LM/W with a 38° beam angle. Offered in 12W, 18W and 24W, all 36mm deep, in white or black.",
    features: [
      "Bridgelux LED engine",
      "Imported driver",
      "120-130 LM/W efficacy",
      "38° beam angle",
      "Yongtek diffuser",
      "Body colour: White / Black",
      "Power factor > 0.90 · 150–240V AC",
      "Slim 36mm surface round",
    ],
  },
  {
    slug: 'pro-232',
    name: "PRO-232",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface Cylinder Downlight",
    image: imgPRO232,
    diagram: diaPRO232,
    wattage: "7W / 12W / 18W",
    cri: "80 / 90",
    cct: "3000K / 4000K / 5000K / 6000K / Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The PRO-232 is a surface-mounted cylindrical downlight with a gun-black aluminium die-cast body and Shinland reflector. It uses CREE LEDs at 130-140 LM/W with selectable 36° and 60° beam angles. Available in 7W, 12W and 18W gun-black finishes.",
    features: [
      "CREE LED engine",
      "Driver: Fulham / Bag",
      "130-140 LM/W efficacy",
      "Beam angle 36° / 60°",
      "Shinland reflector",
      "Body colour: Gun Black",
      "Power factor > 0.90 · 150–240V AC",
      "Surface cylinder · Tunable",
    ],
  },
  {
    slug: 'tlc-052',
    name: "TLC-052",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface Square Mini Spot",
    image: imgTLC052,
    diagram: diaTLC052,
    wattage: "3W",
    cri: "80",
    cct: "3000K / 4000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-052 is a compact surface-mounted square spotlight with an aluminium die-cast body and Shinland reflector. It runs Bridgelux LEDs at 120 LM/W with a 24° beam angle. Supplied at 3W with 35×35×55mm dimensions in white or black.",
    features: [
      "Bridgelux LED engine",
      "Imported driver",
      "120 LM/W efficacy",
      "24° beam angle",
      "Shinland reflector",
      "Body colour: White / Black",
      "Power factor > 0.95 · 150–240V AC",
      "Compact 35×35×55mm",
    ],
  },
  {
    slug: 'tlc-226-surface',
    name: "TLC-226",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface Round Eyelid Light",
    image: imgTLC226,
    diagram: diaTLC226,
    wattage: "3W",
    cri: "80 / 90",
    cct: "3000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-226 is a surface-mounted round eyelid wall light with an aluminium die-cast body. It uses Bridgelux LEDs at 120 LM/W with a 36° beam angle. Supplied at 3W with 80×50mm dimensions, a 55mm cutout, and a white finish.",
    features: [
      "Bridgelux LED engine",
      "Imported driver",
      "120 LM/W efficacy",
      "36° beam angle",
      "Eyelid shielded face",
      "Body colour: White",
      "Power factor > 0.90 · 150–240V AC",
      "80×50mm · 55mm cutout",
    ],
  },
  {
    slug: 'tlc-089',
    name: "TLC-089",
    category: 'Surface Lights',
    categorySlug: 'surface-lights',
    tagline: "Surface Round Mini Light",
    image: imgTLC089,
    diagram: diaTLC089,
    wattage: "5W",
    cri: "80",
    cct: "3000K / 4000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The TLC-089 is a compact surface-mounted round light with an aluminium die-cast body and imported lens. It runs Bridgelux LEDs at 120 LM/W with a 40° beam angle. Supplied at 5W with 60×22mm dimensions in white or black.",
    features: [
      "Bridgelux LED engine",
      "Imported HPF driver",
      "120 LM/W efficacy",
      "40° beam angle",
      "Imported lens",
      "Body colour: White / Black",
      "Power factor > 0.95 · 150–240V AC",
      "Slim 60×22mm surface round",
    ],
  },
  {
    slug: 'mag-lazer',
    name: "Magnetic Lazer",
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: "Magnetic Track Linear Lazer",
    image: imgMAGLAZER,
    diagram: diaMAGLAZER,
    wattage: "6W / 12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The Magnetic Lazer is a magnetic-track linear lazer fitting with OSRAM LEDs delivering 120-130 LM/W. It mounts onto a 48V DC magnetic track and is built from aluminium die casting in a black finish. The compact linear bar runs a row of recessed cell optics for low-glare accent illumination.",
    features: [
      "Magnetic track mount · 48V DC",
      "OSRAM LED engine",
      "Imported driver",
      "120-130 LM/W efficacy",
      "36° beam angle",
      "Recessed cell optics · low glare",
      "Body colour: Black",
      "Tunable CCT · dimmable",
    ],
  },
  {
    slug: 'mag-moveable',
    name: "Magnetic Moveable",
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: "Magnetic Track Moveable Spot",
    image: imgMAGMOVE,
    diagram: diaMAGMOVE,
    wattage: "6W / 12W",
    cri: "80 / 90",
    cct: "3000K / 4000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The Magnetic Moveable is a magnetic-track moveable spot fitting using Bridgelux / OSRAM LEDs with a high 130-140 LM/W output. It mounts on the magnetic track and runs on 150-240V AC mains input via a Tirich driver. The aluminium die-cast body in black houses adjustable spot optics for directional lighting.",
    features: [
      "Magnetic track mount",
      "Bridgelux / OSRAM LED engine",
      "Tirich driver",
      "130-140 LM/W efficacy",
      "36° beam angle",
      "Moveable adjustable head",
      "Body colour: Black",
      "Power factor > 0.90 · 150–240V AC",
    ],
  },
  {
    slug: 'track-spot',
    name: "Track Spotlight",
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: "Magnetic Track Spotlight",
    image: imgTRACKSPOT,
    diagram: diaTRACKSPOT,
    wattage: "7W / 10W / 18W",
    cri: "90",
    cct: "3000K / 4000K / Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The Track is a magnetic-track spotlight fitting with OSRAM LEDs delivering 120-130 LM/W. It mounts on a 48V DC magnetic track and features a cylindrical adjustable head for focused accent lighting. The aluminium die-cast body comes in black across three power options.",
    features: [
      "Magnetic track mount · 48V DC",
      "OSRAM LED engine",
      "Imported driver",
      "120-130 LM/W efficacy",
      "36° beam angle",
      "Cylindrical adjustable head",
      "High CRI 90",
      "Tunable CCT · Body colour: Black",
    ],
  },
  {
    slug: 'caset-lazer',
    name: "Caset Lazer",
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: "Magnetic Recessed Lazer",
    image: imgCASETLAZER,
    diagram: diaCASETLAZER,
    wattage: "6W / 12W",
    cri: "80 / 90",
    cct: "3000K / 4000K / Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The Caset Lazer is a magnetic recessed lazer fitting with OSRAM LEDs producing 120-130 LM/W. It mounts on a 48V DC magnetic track and is constructed from aluminium die casting in black. A row of deep-set cell optics provides low-glare linear accent lighting.",
    features: [
      "Magnetic track mount · 48V DC",
      "OSRAM LED engine",
      "Imported driver",
      "120-130 LM/W efficacy",
      "36° beam angle",
      "Deep-set cell optics · low glare",
      "Body colour: Black",
      "Tunable CCT · dimmable",
    ],
  },
  {
    slug: 'profile',
    name: "Magnetic Profile",
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: "Magnetic Linear Profile",
    image: imgPROFILE,
    diagram: diaPROFILE,
    wattage: "10W / 20W / 30W",
    cri: "80 / 90",
    cct: "3000K / 4000K / Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The Profile is a magnetic-track linear profile fitting with Bridgelux / OSRAM LEDs delivering 120-130 LM/W. It mounts on a 48V DC magnetic track and offers a wide 110° beam for uniform general illumination. The aluminium die-cast body in black is available in lengths up to 900mm.",
    features: [
      "Magnetic track mount · 48V DC",
      "Bridgelux / OSRAM LED engine",
      "Imported driver",
      "120-130 LM/W efficacy",
      "110° wide beam angle",
      "Linear profile up to 900mm",
      "Body colour: Black",
      "Tunable CCT · dimmable",
    ],
  },
  {
    slug: 'wall-washer',
    name: "Profile Wall Washer",
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: "Magnetic Profile Wall Washer",
    image: imgWALLWASHER,
    diagram: diaWALLWASHER,
    wattage: "7W",
    cri: "80",
    cct: "4000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The Profile Wall Washer is a magnetic-track wall washer fitting with OSRAM LEDs and a Yongtek diffuser, delivering 120 LM/W. It mounts on a 48V DC magnetic track with an imported HPF driver. The round aluminium die-cast head provides a wide 110° wash across walls.",
    features: [
      "Magnetic track mount · 48V DC",
      "OSRAM LED engine",
      "Imported HPF driver",
      "120 LM/W efficacy",
      "110° wide wash beam",
      "Yongtek diffuser",
      "Body colour: Black",
      "Power factor > 0.95",
    ],
  },
  {
    slug: 'cylinder',
    name: "Magnetic Cylinder",
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: "Magnetic Track Cylinder",
    image: imgCYLINDER,
    diagram: diaCYLINDER,
    wattage: "7W",
    cri: "80",
    cct: "3000K / 4000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The Cylinder is a magnetic-track cylinder spot fitting with OSRAM LEDs and a GR Optics lens, delivering 120 LM/W. It mounts on a 48V DC magnetic track with an imported HPF driver. The aluminium die-cast cylindrical head provides a focused 36° accent beam.",
    features: [
      "Magnetic track mount · 48V DC",
      "OSRAM LED engine",
      "Imported HPF driver",
      "120 LM/W efficacy",
      "36° beam angle",
      "GR Optics lens",
      "Body colour: Black",
      "Power factor > 0.95",
    ],
  },
  {
    slug: '10z-caset',
    name: "10Z Casetlzr",
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: "Slim Magnetic Caset Lazer",
    image: imgTenZCASET,
    diagram: diaTenZCASET,
    wattage: "5W",
    cri: "80",
    cct: "3000K / 4000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The 10Z Casetlzr is a slim magnetic recessed caset lazer fitting with Bridgelux LEDs delivering 130 LM/W. It mounts on a 48V magnetic track with an imported HPF driver. The compact aluminium die-cast body in black runs a row of cell optics for low-glare accent lighting.",
    features: [
      "Magnetic track mount · 48V",
      "Bridgelux LED engine",
      "Imported HPF driver",
      "130 LM/W efficacy",
      "36° beam angle",
      "Slim 10mm cell profile",
      "Body colour: Black",
      "Low-glare cell optics",
    ],
  },
  {
    slug: '10z-pfl',
    name: "10Z Profile",
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: "Slim Magnetic Linear Profile",
    image: imgTenZPFL,
    diagram: diaTenZPFL,
    wattage: "8W / 12W",
    cri: "80",
    cct: "3000K / 4000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The 10Z PFL is a slim magnetic-track linear profile fitting with Bridgelux LEDs delivering 130 LM/W. It mounts on a 48V magnetic track with an imported HPF driver. The narrow aluminium die-cast body in black offers a wide 110° beam for uniform illumination.",
    features: [
      "Magnetic track mount · 48V",
      "Bridgelux LED engine",
      "Imported HPF driver",
      "130 LM/W efficacy",
      "110° wide beam angle",
      "Slim 10mm profile",
      "Body colour: Black",
      "Power factor > 0.95",
    ],
  },
  {
    slug: '10z-lzr',
    name: "10Z Lazer",
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: "Slim Magnetic Linear Lazer",
    image: imgTenZLZR,
    diagram: diaTenZLZR,
    wattage: "5W / 10W",
    cri: "80",
    cct: "3000K / 4000K / Tunable",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The 10Z LZR is a slim magnetic linear lazer light designed for 48V magnetic track systems. It uses Bridgelux LEDs with a 130 LM/W output, a 36° beam and an aluminium die-cast body. Available in 5W and 10W versions with a Darkoo reflector and high power factor driver.",
    features: [
      "Magnetic track mount · 48V",
      "Bridgelux LED engine",
      "Imported HPF driver",
      "130 LM/W efficacy",
      "36° beam angle",
      "Darkoo anti-glare reflector",
      "Body colour: Black",
      "Tunable · dimmable",
    ],
  },
  {
    slug: '10z-track',
    name: "10Z Track",
    category: 'Track Lights',
    categorySlug: 'track-lights',
    tagline: "Slim Magnetic Track Spot",
    image: imgTenZTRACK,
    diagram: diaTenZTRACK,
    wattage: "3W",
    cri: "80",
    cct: "3000K / 4000K",
    ip: "IP20",
    lifespan: '50,000 hrs',
    description: "The 10Z Track is a compact adjustable magnetic track spotlight for 48V magnetic rail systems. It uses Bridgelux LEDs with a 130 LM/W output, a 36° beam and a Shinland reflector. The aluminium die-cast head tilts for precise accent lighting.",
    features: [
      "Magnetic track mount · 48V",
      "Bridgelux LED engine",
      "Imported HPF driver",
      "130 LM/W efficacy",
      "36° beam angle",
      "Shinland reflector",
      "Adjustable tilting head",
      "Body colour: Black",
    ],
  },
  {
    slug: 'tlc-211',
    name: "TLC-211 / TLC-212",
    category: 'Outdoor Lights',
    categorySlug: 'outdoor-lights',
    tagline: "Outdoor Up-Down Wall Light",
    image: imgTLC211,
    diagram: diaTLC211,
    wattage: "3W / 6W",
    cri: "80",
    cct: "3000K",
    ip: "IP65",
    lifespan: '50,000 hrs',
    description: "The TLC-211 / TLC-212 is an IP65-rated outdoor up/down wall light available in 1-way and 2-way beam configurations. It uses Bridgelux LEDs with 110-120 LM/W output, optic lenses and a 38° beam in a weatherproof aluminium die-cast body. Suitable for facades, entrances and exterior walls.",
    features: [
      "IP65 weatherproof rated",
      "Bridgelux LED engine",
      "Imported driver",
      "110-120 LM/W efficacy",
      "38° beam angle · optic lens",
      "1-way & 2-way versions",
      "Body colour: Grey",
      "Input 150–240V AC 50Hz",
    ],
  },
  {
    slug: 'tlc-213',
    name: "TLC-213 / 214 / 215",
    category: 'Outdoor Lights',
    categorySlug: 'outdoor-lights',
    tagline: "Outdoor Crossed-Beam Wall Light",
    image: imgTLC213,
    diagram: diaTLC213,
    wattage: "3W / 6W / 10W",
    cri: "80",
    cct: "3000K",
    ip: "IP65",
    lifespan: '50,000 hrs',
    description: "The TLC-213/214/215 is an IP65-rated outdoor wall light delivering crossed up-and-down beam effects for exterior facades. It uses Bridgelux LEDs with 110-120 LM/W output, optic lenses and a 38° beam in an aluminium die-cast body. Available in 3W, 6W and 10W versions with a grey finish.",
    features: [
      "IP65 weatherproof rated",
      "Bridgelux LED engine",
      "Imported driver",
      "110-120 LM/W efficacy",
      "38° beam angle · optic lens",
      "Decorative crossed-beam effect",
      "Body colour: Grey",
      "Input 150–240V AC 50Hz",
    ],
  },
  {
    slug: 'tlc-217',
    name: "TLC-217",
    category: 'Outdoor Lights',
    categorySlug: 'outdoor-lights',
    tagline: "Outdoor Round Halo Wall Light",
    image: imgTLC217,
    diagram: diaTLC217,
    wattage: "6W / 9W / 12W",
    cri: "80",
    cct: "3000K / Tunable",
    ip: "IP65",
    lifespan: '50,000 hrs',
    description: "The TLC-217 is an IP65-rated round outdoor wall light producing a soft backlit halo effect. It uses Bridgelux LEDs with 110-120 LM/W output in a weatherproof aluminium die-cast body. Available in 6W, 9W and 12W with tunable, dimmable and DALI control options.",
    features: [
      "IP65 weatherproof rated",
      "Bridgelux LED engine",
      "Imported driver",
      "110-120 LM/W efficacy",
      "Round backlit halo design",
      "Body colour: Grey",
      "Input 150–240V AC 50Hz",
      "Tunable · dimmable · DALI",
    ],
  },
  {
    slug: 'tlc-218',
    name: "TLC-218 (Flood Light)",
    category: 'Fixtures',
    categorySlug: 'fixtures',
    tagline: "LED Flood Light",
    image: imgTLC218,
    diagram: diaTLC218,
    wattage: "50W / 100W / 200W",
    cri: "80",
    cct: "3000K / 4000K / 6000K",
    ip: "IP65",
    lifespan: '50,000 hrs',
    description: "The TLC-218 is a high-output LED flood light using Bridgelux and OSRAM LEDs with 120-130 LM/W output and a wide 120° beam. It is built in an aluminium die-cast body for outdoor area and facade lighting. Available in 50W, 100W and 200W with selectable colour temperatures.",
    features: [
      "IP65 weatherproof rated",
      "Bridgelux / OSRAM LED engine",
      "Imported driver",
      "120-130 LM/W efficacy",
      "120° wide beam angle",
      "50W / 100W / 200W",
      "Body colour: Grey",
      "Input 150–240V AC 50Hz",
    ],
  },
  {
    slug: 'tlc-219',
    name: "TLC-219 (Street Light)",
    category: 'Fixtures',
    categorySlug: 'fixtures',
    tagline: "LED Street Light",
    image: imgTLC219,
    diagram: diaTLC219,
    wattage: "24W / 50W / 100W",
    cri: "80",
    cct: "3000K / 4000K / 6000K",
    ip: "IP65",
    lifespan: '50,000 hrs',
    description: "The TLC-219 is an LED street light using Bridgelux and OSRAM LEDs with 110-120 LM/W output and a wide 120° beam for road and pathway illumination. It features optic lenses in an aluminium die-cast body for outdoor durability. Available in 24W, 50W and 100W with selectable colour temperatures.",
    features: [
      "IP65 weatherproof rated",
      "Bridgelux / OSRAM LED engine",
      "Imported driver",
      "110-120 LM/W efficacy",
      "120° wide beam · optic lens",
      "24W / 50W / 100W",
      "Body colour: Grey",
      "Input 150–240V AC 50Hz",
    ],
  },
  {
    slug: 'tlc-221',
    name: "TLC-221 (Spike Light)",
    category: 'Outdoor Lights',
    categorySlug: 'outdoor-lights',
    tagline: "Garden Spike Light",
    image: imgTLC221,
    diagram: diaTLC221,
    wattage: "7W / 12W",
    cri: "80",
    cct: "3000K / 4000K / 6000K / RGB",
    ip: "IP65",
    lifespan: '50,000 hrs',
    description: "The TLC-221 is an IP65-rated garden spike light for landscape and plant accenting. It uses Bridgelux LEDs with 110-120 LM/W output, an optic reflector and a 38° beam in an adjustable aluminium die-cast body. Available in 7W and 12W with white CCT options plus Red, Green and Blue colour choices.",
    features: [
      "IP65 weatherproof rated",
      "Bridgelux LED engine",
      "Imported driver",
      "110-120 LM/W efficacy",
      "38° beam · optic reflector",
      "White CCT + RGB options",
      "Adjustable ground-spike mount",
      "Input 150–240V AC 50Hz",
    ],
  },
  {
    slug: 'tlc-222',
    name: "TLC-222",
    category: 'Outdoor Lights',
    categorySlug: 'outdoor-lights',
    tagline: "Outdoor Round Wall Light",
    image: imgTLC222,
    diagram: diaTLC222,
    wattage: "6W",
    cri: "80",
    cct: "3000K",
    ip: "IP65",
    lifespan: '50,000 hrs',
    description: "The TLC-222 is an IP65-rated round outdoor wall light with a half-shielded face for soft downward illumination. It uses Bridgelux LEDs with 120-130 LM/W output and a wide 110° beam in an aluminium die-cast body. Supplied in 6W with a grey finish for exterior walls and pathways.",
    features: [
      "IP65 weatherproof rated",
      "Bridgelux LED engine",
      "Imported driver",
      "120-130 LM/W efficacy",
      "110° wide beam angle",
      "Round shielded face",
      "Body colour: Grey",
      "Input 150–240V AC 50Hz",
    ],
  },
  {
    slug: 'tlc-223',
    name: "TLC-223 (Step Light)",
    category: 'Outdoor Lights',
    categorySlug: 'outdoor-lights',
    tagline: "Outdoor Step Light",
    image: imgTLC223,
    diagram: diaTLC223,
    wattage: "6W",
    cri: "80 / 90",
    cct: "3000K",
    ip: "IP65",
    lifespan: '50,000 hrs',
    description: "The TLC-223 is an IP65-rated outdoor step light providing low-level directional illumination for stairs and pathways. It uses Bridgelux LEDs with a high 130-140 LM/W output and a wide 110° beam in an aluminium die-cast body. Supplied in 6W with a grey finish.",
    features: [
      "IP65 weatherproof rated",
      "Bridgelux LED engine",
      "Tirich driver",
      "130-140 LM/W efficacy",
      "110° wide beam angle",
      "Wall-mounted step light",
      "Body colour: Grey",
      "Input 150–240V AC 50Hz",
    ],
  },
  {
    slug: 'pro-224',
    name: "PRO-224",
    category: 'Outdoor Lights',
    categorySlug: 'outdoor-lights',
    tagline: "Outdoor Recessed Step Light",
    image: imgPRO224,
    diagram: diaPRO224,
    wattage: "6W / 8W",
    cri: "80 / 90",
    cct: "3000K",
    ip: "IP65",
    lifespan: '50,000 hrs',
    description: "The PRO-224 is an IP65-rated outdoor step and recessed wall light built from aluminium die casting for weatherproof durability. It uses Bridgelux LEDs with a wide 110° beam angle and delivers 130-140 LM/W. Designed for pathways, stairs and low-level wall mounting in exposed environments.",
    features: [
      "IP65 weatherproof rated",
      "Bridgelux LED engine",
      "Tirich driver",
      "130-140 LM/W efficacy",
      "110° wide beam angle",
      "Recessed step / wall mount",
      "Body colour: Grey / Black",
      "Power factor > 0.90 · 150–240V AC",
    ],
  },
  {
    slug: 'tlc-216',
    name: "TLC-216",
    category: 'Outdoor Lights',
    categorySlug: 'outdoor-lights',
    tagline: "Outdoor Up-Down Wall Light",
    image: imgTLC216,
    diagram: diaTLC216,
    wattage: "4W / 8W",
    cri: "80 / 90",
    cct: "3000K",
    ip: "IP65",
    lifespan: '50,000 hrs',
    description: "The TLC-216 is an IP65-rated outdoor up/down wall light constructed from aluminium die casting for reliable weatherproof performance. It pairs Bridgelux LEDs with a Tirich driver, offering a 110° beam angle and 130-140 LM/W efficiency. Ideal for facade and exterior wall accent lighting.",
    features: [
      "IP65 weatherproof rated",
      "Bridgelux LED engine",
      "Tirich driver",
      "130-140 LM/W efficacy",
      "110° beam · up/down output",
      "Body colour: Grey",
      "Power factor > 0.90 · 150–240V AC",
      "Facade & exterior wall light",
    ],
  },
  {
    slug: 'tlc-220',
    name: "TLC-220",
    category: 'Outdoor Lights',
    categorySlug: 'outdoor-lights',
    tagline: "Outdoor Surface Round Spot",
    image: imgTLC220,
    diagram: diaTLC220,
    wattage: "3W",
    cri: "80 / 90",
    cct: "3000K",
    ip: "IP65",
    lifespan: '50,000 hrs',
    description: "The TLC-220 is an IP65-rated outdoor surface-mounted round light made from aluminium die casting for weatherproof use. It features a Bridgelux LED with a focused 38° beam angle and 130-140 LM/W output in a compact 65mm round body. Suited to accent and spot illumination on exterior ceilings and soffits.",
    features: [
      "IP65 weatherproof rated",
      "Bridgelux LED engine",
      "130-140 LM/W efficacy",
      "38° focused beam angle",
      "Surface-mounted round form",
      "Body colour: Black",
      "Power factor > 0.90 · 150–240V AC",
      "Compact 65×15mm",
    ],
  },
  {
    slug: 'pro-227',
    name: "PRO-227",
    category: 'Outdoor Lights',
    categorySlug: 'outdoor-lights',
    tagline: "Outdoor Garden Spike Light",
    image: imgPRO227,
    diagram: diaPRO227,
    wattage: "3W / 7W / 12W",
    cri: "80 / 97",
    cct: "3000K / 4000K / 6000K",
    ip: "IP65",
    lifespan: '50,000 hrs',
    description: "The PRO-227 is an IP65-rated outdoor garden spike light built from aluminium die casting with a Shinland diffuser for weatherproof landscape use. It uses CREE LEDs with a focused 38° beam and 130-140 LM/W output, available in three CCT options. Designed for spiking into garden beds to highlight plants, trees and pathways.",
    features: [
      "IP65 weatherproof rated",
      "CREE LED engine",
      "130-140 LM/W efficacy",
      "38° focused beam angle",
      "Shinland diffuser",
      "Garden ground-spike mount",
      "CRI up to 97 · Body colour: Grey",
      "Power factor > 0.97 · 150–240V AC",
    ],
  },
];

// ── Split magnetic-track fittings out of "Track Lights" ─────────────
// These 48V magnetic-track products were historically grouped under
// Track Lights; they now live in their own "Magnetic Track" category.
// (tlc-121/123/124 and cylinder-track stay under Track Lights — they are
// surface/universal-track spotlights, not magnetic.)
const MAGNETIC_SLUGS = new Set([
  'magnetic-cob', '10z-caset-lazer', '10z-lazer',
  'mag-lazer', 'mag-moveable', 'track-spot', 'caset-lazer',
  'profile', 'wall-washer', 'cylinder',
  '10z-caset', '10z-pfl', '10z-lzr', '10z-track',
]);
for (const _p of ALL_PRODUCTS) {
  if (MAGNETIC_SLUGS.has(_p.slug)) {
    _p.category = 'Magnetic Track';
    _p.categorySlug = 'magnetic-track';
  }
}

// Published catalogue: PRO-116 plus the products extracted from the PDF
// (pages 15–21, 23, 28, 50). To restore the full catalogue, change this
// back to `export const PRODUCTS = ALL_PRODUCTS;`
const PUBLISHED_SLUGS = [
  'pro-116', // p15
  'pro-125', // p16
  'pro-120', // p17
  'pro-126', // p18
  'tlc-109', // p19
  'tlc-111', // p20
  'pro-115', // p21
  'tlc-107', // p23
  'tlc-118', // p24
  'tlc-105', // p25
  'tlc-159', // p26
  'tlc-102', // p27
  'tlc-103', // p28
  'tlc-113', // p31
  'tlc-112', // p32
  'tlc-335', // p33
  'tlc-119', // p34
  'tlc-114', // p36
  'pro-142', // p37
  'pro-141', // p38
  'pro-140', // p50
  'tlc-004', // p38
  'pro-130', // p39
  'pro-013', // p40
  'pro-133', // p41
  'pro-131', // p42
  'pro-132', // p43
  'pro-127', // p44
  'tlc-108', // p47
  'tlc-129', // p48
  'pro-128', // p49
  'tlc-101', // p50
  'tlc-106', // p51
  'pro-117', // p52
  'tlc-144', // p53
  'tlc-135', // p54
  'tlc-143', // p55
  'tlc-145', // p56
  'tlc-338', // p58
  'tlc-311', // p59
  'tlc-334', // p60
  'tlc-333', // p61
  'pro-340', // p62
  'pro-240', // p64
  'tlc-204', // p65
  'tlc-344', // p66
  'tlc-339', // p67
  'pro-154', // p69
  'tlc-153', // p70
  'tlc-152', // p71
  'tlc-151', // p72
  'pro-014', // p73
  'pro-054', // p74
  'tlc-124', // p76
  'tlc-123', // p77
  'tlc-121', // p78
  'pro-210', // p81
  'tlc-208', // p82
  'pro-209', // p83
  'pro-207', // p84
  'tlc-201', // p85
  'tlc-206', // p86
  'tlc-205', // p88
  'tlc-203', // p89
  'tlc-155', // p90
  'pro-230', // p91
  'tlc-444', // p93
  'pro-232', // p94
  'tlc-052', // p96
  'tlc-226', // p97
  'tlc-089', // p100
  'mag-lazer', // p102
  'mag-moveable', // p103
  'track-spot', // p104
  'caset-lazer', // p106
  'profile', // p107
  'wall-washer', // p110
  'cylinder', // p115
  '10z-caset', // p116
  '10z-pfl', // p117
  '10z-lzr', // p118
  '10z-track', // p119
  'tlc-211', // p124
  'tlc-213', // p125
  'tlc-217', // p127
  'tlc-218', // p128
  'tlc-219', // p129
  'tlc-221', // p131
  'tlc-222', // p132
  'tlc-223', // p133
  'pro-224', // p134
  'tlc-216', // p136
  'tlc-220', // p137
  'pro-227', // p138
];
const _BY_SLUG = new Map();
for (const _p of ALL_PRODUCTS) _BY_SLUG.set(_p.slug, _p); // last definition wins
export const PRODUCTS = PUBLISHED_SLUGS
  .map((slug) => _BY_SLUG.get(slug))
  .filter(Boolean);

const ALL_CATEGORIES = [
  // {
  //   slug: 'panel-lights',
  //   label: 'Panel Lights',
  //   desc: 'Surface & recessed panels for offices and commercial spaces',
  //   cover: hdTLC121,
  // },
  {
    slug: 'cob-lights',
    label: 'COB Lights',
    desc: 'High-output COB spots and recessed fixtures with tight beam control',
    cover: hdPRO116,
  },
  {
    slug: 'downlights',
    label: 'Downlights',
    desc: 'Precision recessed fixtures for targeted beam control',
    cover: hdTLC108,
  },
  {
    slug: 'linear-lights',
    label: 'Linear Lights',
    desc: 'Recessed multi-cell grille bars for continuous linear accents',
    cover: hdTLC152,
  },
  {
    slug: 'track-lights',
    label: 'Track Lights',
    desc: 'Surface-mount & universal-track COB spotlights',
    cover: imgTLC121,
  },
  {
    slug: 'magnetic-track',
    label: 'Magnetic Track',
    desc: 'Slim 48V magnetic-track spots, lazers, profiles & washers',
    cover: hdMagCOB,
  },
  {
    slug: 'fixtures',
    label: 'Fixtures',
    desc: 'Industrial-grade high-bay and tri-proof fixtures',
    cover: hdTLC333,
  },
  {
    slug: 'pendant-lights',
    label: 'Pendant Lights',
    desc: 'Designer hanging fixtures for premium spaces',
    cover: hdHanging,
  },
  {
    slug: 'strip-leds',
    label: 'Strip LEDs',
    desc: 'Flexible strips for architectural and accent lighting',
    cover: stripLed,
  },
  {
    slug: 'surface-lights',
    label: 'Surface Lights',
    desc: 'Surface-mounted cylinders, spots and ceiling fixtures',
    cover: imgPRO207,
  },
  {
    slug: 'outdoor-lights',
    label: 'Outdoor Lights',
    desc: 'Weatherproof IP65 wall, step, spike and facade lighting',
    cover: imgTLC221,
  },
];

// Only show categories that have at least one published product.
export const CATEGORIES = ALL_CATEGORIES.filter((c) =>
  PRODUCTS.some((p) => p.categorySlug === c.slug)
);
